{
    "ABSTRACT_MANAGEMENT": "Abstract Management",
    "ACCESS": "Access",
    "ACCESS_CODE": "Access code",
    "ACCESS_KEY": "Access key",
    "ACCOUNT": "Account",
    "ACCOUNTING": "Accounting",
    "ACCOUNTING_FIELDS": "Accounting fields",
    "ACCOUNT_SLUG": "Account name slug",
    "ACTION": "Action",
    "ACTIONS": "Actions",
    "ACTION_TYPE": "Action type",
    "ACTIVATE": "Activate",
    "ACTIVATE_COMBINED_FIELDS": "Activate combined fields",
    "ACTIVE": "Active",
    "ACTIVE_EVENTS_WITH_ARCHIVED_PARTICIPANTS": "Active Events with archived participants",
    "ACTIVITIES": "Activities",
    "ACTIVITIES_CART": "Activities cart",
    "ACTIVITIES_CART_BLOCK_TITLE": "Activities cart - This is a sample preview of the activity cart",
    "ACTIVITIES_CREATE": "Add sessions",
    "ACTIVITIES_DELETE": "Delete sessions",
    "ACTIVITIES_READ": "View sessions",
    "ACTIVITIES_UPDATE": "Edit sessions",
    "ACTIVITY": "Activity",
    "ACTIVITY_CONDITION": "Activity condition",
    "ACTIVITY_CONDITIONS": "Activity conditions",
    "ACTIVITY_CONDITION_MAXIMUM_FIELD_VALUE_MUST_BE_GREATER_THAN_OR_EQUAL_TO_1": "Activity condition Maximum field value must be greater than or equal to 1",
    "ACTIVITY_DESCRIPTION": "Activity description",
    "ACTIVITY_DETAILS": "Activity details",
    "ACTIVITY_END": "Activity end",
    "ACTIVITY_FIELDS": "Activity fields",
    "ACTIVITY_GENERIC_SETTINGS": "Activity generic settings",
    "ACTIVITY_GROUP": "Activity group",
    "ACTIVITY_GROUPS": "Activity groups",
    "ACTIVITY_LISTING": "Activity listing",
    "ACTIVITY_MANAGEMENT": "Activity Management",
    "ACTIVITY_NAME": "Activity name",
    "ACTIVITY_PARTICIPANT": "Activity participant",
    "ACTIVITY_PARTICIPANTS": "Activity participants",
    "ACTIVITY_PARTICIPANT_GROUP_BY_STATUS_WIDGET_DESCRIPTION": "Activity participant group by status widget description",
    "ACTIVITY_PARTICIPANT_GROUP_BY_STATUS_WIDGET_EXAMPLE": "Activity participant group by status widget example",
    "ACTIVITY_PARTICIPANT_GROUP_BY_STATUS_WIDGET_TITLE": "Activity participant group by status",
    "ACTIVITY_PARTICIPANT_STATUSES": "Activity participant statuses",
    "ACTIVITY_PARTICIPANT_STATUS_CHANGED": "Activity status changed",
    "ACTIVITY_PARTICIPANT_STATUS_CHANGED_TRIGGER": "Activity status changed trigger",
    "ACTIVITY_REGISTRATION": "Activity registration",
    "ACTIVITY_ROOM": "Activity room",
    "ACTIVITY_SETTINGS": "Activity settings",
    "ACTIVITY_SHORT_NAME": "Activity short-name",
    "ACTIVITY_SPEAKER_INFO": "Activity speaker info",
    "ACTIVITY_START": "Activity start",
    "ACTIVITY_STATUS": "Activity status",
    "ACTIVITY_STATUS_ACTIVE": "Active",
    "ACTIVITY_STATUS_INACTIVE": "Inactive",
    "ACTIVITY_SUMMARY": "Activity summary",
    "ACTIVITY_URL": "Activity URL",
    "ACTIVITY_VISIBILITY": "Activity visibility",
    "ACTIVITY_WAITING_LIST": "Activity waiting list",
    "ACTVITIES_CREATE": "Add sessions",
    "ACTVITIES_DELETE": "Delete sessions",
    "ACTVITIES_READ": "View sessions",
    "ACTVITIES_UPDATE": "Edit sessions",
    "ADD": "Add",
    "ADDITIONAL_CONTENT_PAGES_VISIBLE_IN_THIS_WORKFLOW": "Additional content pages visible in this workflow",
    "ADDITIONAL_PAGES": "Pages visible in this workflow",
    "ADDITIONAL_SECTIONS": "Additional sections",
    "ADDRESS": "Address",
    "ADD_ACTION_BLOCK": "Add ACTION block",
    "ADD_ASSET": "Add Asset",
    "ADD_AS_MODERATOR": "Add as moderator",
    "ADD_AS_SPEAKER": "Add as speaker",
    "ADD_CONDITION": "Add condition",
    "ADD_CONTACTS_TO_EVENT": "Add contacts to event",
    "ADD_CUSTOM_FIELD": "Add custom field",
    "ADD_DEPENDENCY": "Add dependency",
    "ADD_EVENT": "Add event",
    "ADD_EVENT_TO_SERIES": "Add event to series",
    "ADD_FIELD_MAPPING": "Add field mapping",
    "ADD_FIELD_VALUES": "Add field values",
    "ADD_FOOTER": "Add footer",
    "ADD_HEADER": "Add header",
    "ADD_LANGUAGE": "Add language",
    "ADD_MODERATORS": "Add moderators",
    "ADD_NEW": "Add new",
    "ADD_NEW_CONTACTS": "Add new contacts",
    "ADD_NEW_DEPENDENCY_FILTERS": "Add new dependency filters",
    "ADD_NEW_EVENT_PARTICIPANT": "Add new event participant",
    "ADD_NEW_FONT": "Add new font",
    "ADD_NEW_IMAGE_FOR_SAME_POSITION_ON_BADGE": "Add new image for same position on badge",
    "ADD_NEW_PARTICIPANT": "Add new participant",
    "ADD_NEW_PARTICIPANTS": "Add new participants",
    "ADD_NUMBER": "Add number",
    "ADD_PARAMETERS": "Add parameters",
    "ADD_PARTICIPANTS": "Add participants",
    "ADD_PARTICIPANTS_TO_MODERATION": "Add participants to moderation",
    "ADD_PARTICIPANT_TO_ACTIVITY_AS_MODERATOR_DIALOG_ARE_YOU_SURE": "Are you sure you want to add selected participants as moderators to the activity?",
    "ADD_PARTICIPANT_TO_ACTIVITY_AS_MODERATOR_DIALOG_TITLE": "Add to activity as moderator",
    "ADD_PARTICIPANT_TO_ACTIVITY_AS_SPEAKER_DIALOG_ARE_YOU_SURE": "Are you sure you want to add selected participants as speakers to the activity?",
    "ADD_PARTICIPANT_TO_ACTIVITY_AS_SPEAKER_DIALOG_TITLE": "Add to activity as speaker",
    "ADD_PARTICIPANT_TO_ACTIVITY_DIALOG_ARE_YOU_SURE": "Are you sure you want to add selected participants to the activity?",
    "ADD_PARTICIPANT_TO_ACTIVITY_DIALOG_TITLE": "Add to activity",
    "ADD_PROCESS": "Add process",
    "ADD_PROCESS_FLOW_STEP": "Add Process-Flow step",
    "ADD_PRODUCTS": "Add products",
    "ADD_QUERY_BLOCK": "Add QUERY block",
    "ADD_ROOM": "Add room",
    "ADD_SEAT": "Add seat",
    "ADD_SEATS": "Add seats",
    "ADD_SINGLE_CONTACT": "Add single contact",
    "ADD_SINGLE_ORGANIZATION": "Add single organization",
    "ADD_SINGLE_PARTICIPANT": "Add single participant",
    "ADD_STAGE": "Add stage",
    "ADD_STEP": "Add step",
    "ADD_TEAM": "Add team",
    "ADD_TEAMS": "Add teams",
    "ADD_THEME": "Add theme",
    "ADD_TOOLTIP": "Add tooltip",
    "ADD_TO_ACTIVITY": "Add to activity",
    "ADD_TO_CALENDAR": "Add to calendar",
    "ADD_TO_EVENT": "Add to Event",
    "ADD_TO_EVENT_NAME": "Add to event name",
    "ADD_VIDEO_INTEGRATION": "Add video integration",
    "ADD_WAIT_BLOCK": "Add wait block",
    "ADD_WEBHOOK_TO": "Copy the URL below into the Stripe \"Add end point\" section, in the Webhooks menu",
    "ADD_WIDGET": "Add widget",
    "ADMINISTRATOR": "Administrator",
    "ADMINISTRATORS": "Administrators",
    "ADVANCED_OPTIONS": "Advanced options",
    "ADVANCED_QUERY": "Advanced-query",
    "ADVANCED_SEARCH": "Advanced search",
    "AFTER": "After",
    "AFTER_INVITATION_SEQUENCE": "After invitation sequence",
    "AFTER_PAYMENT_ACTIONS": "After payment actions",
    "AFTER_PAYMENT_SEQUENCE": "After payment sequence",
    "AFTER_PAYMENT_WAITING_LIST_ACTIONS": "After payment actions",
    "AFTER_PAYMENT_WAITING_LIST_COMPLETED_ACTIONS": "After payment completed actions",
    "AFTER_PUBLIC_INVITATION_ACTIONS": "After public invitation actions",
    "AFTER_REGISTRATIONS": "After registrations",
    "AFTER_REGISTRATION_ACTIONS": "After registration actions",
    "AFTER_REGISTRATION_SEQUENCE": "After registration sequence",
    "AFTER_SO_MANY_OCCURRENCES": "After so many occurrences",
    "AFTER_WAITING_LIST_REGISTRATION": "After waiting list registration",
    "AGENDA": "Agenda",
    "AGENDA_LISTING": "Agenda listing",
    "ALIGNMENT": "Alignment",
    "ALL": "All",
    "ALLOW": "Allow",
    "ALLOW_FULL_VIEW_ACESS_FOR_ALL_USERS_OF_THIS_REPORT": "Allow full view access for all users of this report",
    "ALLOW_PAYMENTS_BY_INVOICE_IN_ADDITION_TO_ONLINE_PAYMENTS": "Allow payments by invoice in addition to online payments",
    "ALLOW_REGISTRATION": "Allow registration",
    "ALLOW_RESERVING_OR_BUYING_MORE_THAN_ONE_PRODUCT": "Allow reserving or buying more than one product",
    "ALL_EVENTS": "All events",
    "ALL_FIELDS": "All fields",
    "ALL_PARTICIPANTS": "All participants",
    "ALL_VALUES_MUST_BE_POSITIVE": "All values must be 0 or higher",
    "ALWAYS_UPDATE_CRM_CONTACT_VALUE_TO_EVENT_PARTICIPANT_VALUE": "Always update CRM contact value to Event Participant value",
    "AMENITIES": "Amenities",
    "AMENITY": "Amenity",
    "AMOUNT": "Amount",
    "ANGLE": "Angle",
    "ANSWERS": "Answers",
    "AN_EMAIL_WILL_BE_SEND_WHEN_THE_IMPORT_HAS_BEEN_COMPLETED": "An email will be send when the import has been completed",
    "API_ACCESS_TOKEN": "API access token",
    "API_CLIENT": "API client",
    "API_CLIENTS": "API clients",
    "API_CLIENT_DETAILS": "API Client details",
    "API_CLIENT_FIELDS": "API client fields",
    "API_KEY": "API key",
    "API_SECRET": "API Secret",
    "APPLICABLE_EVENTS": "Applicable events",
    "APPLY": "Apply",
    "APPLY_CANCELLATION_COSTS": "Apply standard cancellation fee and policies",
    "APPLY_CANCELLATION_TERMS": "Apply cancellation terms",
    "APPLY_CHANGES": "Apply changes",
    "APPLY_FILTER": "Apply filter",
    "APPLY_FULL_REFUND_AT_ANY_TIME_WITH_APPROVED_EXCEPTION": "Apply full refund at any time with approved exception",
    "APPLY_TEAMS": "Apply teams",
    "APPLY_THEME_GLOBALLY": "Apply theme globally",
    "APPROVAL": "Approval",
    "APPROVAL_EMAIL_1": "Approval Email-Field 1",
    "APPROVAL_EMAIL_2": "Approval Email-Field 2",
    "APPROVAL_EMAIL_FIELD": "Approval email field",
    "APPROVAL_REQUEST_EMAIL": "Approval Email",
    "APPROVAL_REQUIRED": "Approval required",
    "APPROVED": "Approved",
    "APPROVED_AT": "Approved at",
    "APP_SETTINGS": "App settings",
    "ARCHIVE": "Archive",
    "ARCHIVED": "Archived",
    "ARCHIVED_EVENTS": "Archived events",
    "ARCHIVED_EVENTS_CAN_BE_RETRIEVED_IN_THE_ARCHIVED_EVENTS_SECTION": "Archived events can be retrieved in the archived events section",
    "ARCHIVED_EVENT_TEMPLATES_CAN_BE_RETRIEVED_IN_THE_ARCHIVED_EVENTS_SECTION": "Archived event templates can be retrieved in the archived events section",
    "ARCHIVED_PARTICIPANTS": "Archived participants",
    "ARCHIVED_PARTICIPANTS_CAN_BE_RETRIEVED": "Archived participants can be retrieved in the Organization menu section",
    "ARCHIVE_DISCOUNT_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected discount?",
    "ARCHIVE_DISCOUNT_DIALOG_TITLE": "Archive discount",
    "ARCHIVE_EVENTS_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected event?",
    "ARCHIVE_EVENTS_CONFIRMATION_DIALOG_TITLE": "Archive Event",
    "ARCHIVE_EVENT_APP_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive selected event app?",
    "ARCHIVE_EVENT_APP_DIALOG_TITLE": "Archive event app",
    "ARCHIVE_EVENT_TEMPLATE_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected event template?",
    "ARCHIVE_EVENT_TEMPLATE_CONFIRMATION_DIALOG_TITLE": "Archive Event Template",
    "ARCHIVE_GLOBAL_REPORT_CONFIRMATION_DIALOG_CONTENT": "Are you sure you want to archive the selected global report?",
    "ARCHIVE_GLOBAL_REPORT_CONFIRMATION_DIALOG_TITLE": "Archive global report",
    "ARCHIVE_PRODUCT_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to archive the selected product(s)?",
    "ARCHIVE_PRODUCT_DIALOG_TITLE": "Archive product(s)",
    "ARCHIVE_REPORTS_CONFIRMATION_DIALOG_CONTENT": "Are you sure you want to archive the selected reports?",
    "ARCHIVE_REPORTS_CONFIRMATION_DIALOG_TITLE": "Archive reports",
    "ARCHIVE_WORKFLOWS_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected workflow?",
    "ARCHIVE_WORKFLOWS_CONFIRMATION_DIALOG_TITLE": "Archive workflow",
    "ARRIVAL_TIME": "Arrival time",
    "ARRIVAL_WORKFLOW_EXPLANATION": "Arrival: manage the arrival of participants to the event",
    "ARRIVAL_WORKFLOW_NAME": "Arrival",
    "ARRIVED": "Arrived",
    "ARRIVED_AT": "Arrived at",
    "ASPECT_RATIO": "Aspect ratio",
    "ASSET": "Asset",
    "ASSETS": "Documents",
    "ASSETS_CREATE": "Add event assets",
    "ASSETS_DELETE": "Delete event assets",
    "ASSETS_READ": "View event assets",
    "ASSETS_TAB": "Assets",
    "ASSETS_UPDATE": "Edit event assets",
    "ASSIGN_ADMINS_TO_TEAM": "Assign admins to the team",
    "ASSIGN_CONTACTS_TO_EVENTS": "Assign contacts to events",
    "ASSIGN_CONTACTS_TO_ORGANIZATION": "Assign contacts to organization",
    "ASSIGN_EVENTS": "Assign events",
    "ASSIGN_EVENTS_TO_PROJECT": "Assign event(s) to Project",
    "ASSIGN_EVENT_OR_EVENT_TEMPLATE": "Assign events or event templates",
    "ASSIGN_EVENT_TEMPLATES": "Assign event templates",
    "ASSIGN_EVENT_TEMPLATES_TO_PRODUCT_GROUP": "Assign Event Template(s) to Product Group",
    "ASSIGN_EVENT_TO_PRODUCT_GROUP": "Assign Event(s) to Product Group",
    "ASSIGN_PARTICIPANTS_TO_EVENT": "Assign participant(s) to event",
    "ASSIGN_PARTICIPANTS_TO_TEAMS": "Assign participants to teams",
    "ASSIGN_PRODUCTS": "Assign products",
    "ASSIGN_PRODUCTS_TO_PRODUCT_GROUP": "Add products to product group",
    "ASSIGN_PRODUCT_TO_PRODUCT_GROUP": "Add the product to selected product groups",
    "ASSIGN_REPORT_TO_TEAMS": "Assign report to teams",
    "ASSIGN_ROLES_MENU_ACTION": "Assign roles",
    "ASSIGN_ROLES_TO_TEAM": "Assign roles to the team",
    "ASSIGN_ROLES_TO_TEAMS": "Assign roles to teams",
    "ASSIGN_ROLE_TO_TEAMS": "Assign role to teams",
    "ASSIGN_SYSTEM_FONTS_TO_EVENT": "Assign System Fonts to Event",
    "ASSIGN_TASK": "Assign task",
    "ASSIGN_TEAMS": "Assign teams",
    "ASSIGN_TEAMS_TO_EVENT": "Assign teams to event",
    "ASSIGN_TEAMS_TO_EVENT_APP": "Assign teams to event app",
    "ASSIGN_TEAMS_TO_EVENT_PARTICIPANT": "Assign teams to event participant",
    "ASSIGN_TEAMS_TO_INTEGRATION": "Assign teams to integration",
    "ASSIGN_TEAMS_TO_PROJECT": "Assign team(s) to project",
    "ASSIGN_TEAMS_TO_TASK": "Assign team(s) to task",
    "ASSIGN_TEAMS_TO_THEME": "Assign teams to theme",
    "ASSIGN_TO_PRODUCT_GROUPS": "Assign to product groups",
    "ASSIGN_TO_TEAM": "Assign to team",
    "ASSIGN_TO_TEAMS": "Assign to teams",
    "ASSIGN_USERS": "Assign users",
    "ASSIGN_USERS_MENU_ACTION": "Assign users",
    "ASSIGN_USERS_TO_EVENT": "Assign user(s) to event",
    "ASSIGN_USERS_TO_TASK": "Assign user(s) to task",
    "ASSIGN_USERS_TO_TEAM": "Assign users to the team",
    "ASSIGN_USERS_TO_TEAMS": "Assign users to teams",
    "ASSIGN_USER_TO_TEAMS": "Assign the user to teams",
    "ATTRIBUTE_MAPPING": "Attribute mapping",
    "AT_LEAST_ONE_ACTIVITY_IS_REQUIRED": "At least one activity is required",
    "AT_LEAST_ONE_COLUMN_MUST_BE_SELECTED": "At least one column must be selected",
    "AT_LEAST_ONE_ITEM_IS_REQUIRED": "At least one item is required",
    "AT_LEAST_ONE_ITEM_MUST_BE_SELECTED": "At least one item must be selected",
    "AT_LEAST_ONE_LANGUAGE_MUST_BE_SELECTED": "At least one language must be selected",
    "AT_LEAST_ONE_TEAM_MUST_BE_SELECTED": "At least one team must be selected",
    "AT_SEND": "At send",
    "AUDIENCE": "Audience",
    "AUDIENCE_STATUS_ALREADY_SENT_IN_PREVIOUS_SCHEDULE": "Already sent in previous schedule",
    "AUDIENCE_STATUS_BOUNCED": "Bounced",
    "AUDIENCE_STATUS_ERROR": "Error",
    "AUDIENCE_STATUS_PLANNED": "Planned",
    "AUDIENCE_STATUS_SENT": "Sent",
    "AUDIT": "Audit",
    "AUDIT_LOG_ENTRY": "Audit log entry",
    "AUTHORIZATION": "Authorization",
    "AUTHORIZATION_MODE": "Authorization mode",
    "AUTHORIZE": "Authorize",
    "AUTH_TYPE": "Authentication type",
    "AUTOMATIONS": "Automations",
    "AVAILABLE_COLUMNS": "Available columns",
    "AVAILABLE_FIELDS": "Available fields",
    "AVAILABLE_FORMS": "Available forms",
    "AVAILABLE_FROM": "Available from",
    "AVAILABLE_PAGES": "Available pages",
    "AVAILABLE_UNTIL": "Available until",
    "AZA2_ACCESS": "Access Azavista 2.0 API and On-site app",
    "AZA2_API": "Access Azavista 2.0",
    "AZAVISTA": "Azavista",
    "AZAVISTA2_SCOPES": "Access Azavista 2.0",
    "AZAVISTA_2_0_EVENT_ID": "Azavista 2.0 Event ID",
    "AZAVISTA_ADMIN": "Azavista admin",
    "AZAVISTA_FIELD": "Azavista field",
    "AZAVISTA_FIELD_NAME": "Azavista field name",
    "AZAVISTA_FIELD_TYPE": "Azavista field type",
    "AZAVISTA_ID": "Azavista ID",
    "AZAVISTA_MODULE": "Azavista module",
    "AZAVISTA_ONBOARDING": "Azavista onboarding",
    "AZAVISTA_STATUS_FIELD": "Azavista status field",
    "AZAVISTA_TWO_SYNC": "Azavista 2.0 sync",
    "BACK_TO_DETAILS": "Back to details",
    "BACK_TO_LIST": "Back to list",
    "BACK_TO_LOGIN": "Back to Login",
    "BADGE": "Badge",
    "BADGES": "Badges",
    "BADGE_DESIGN": "Badge design",
    "BADGE_DESIGN_BACK": "Badge Design - Back",
    "BADGE_DESIGN_FRONT": "Badge Design - Front",
    "BADGE_EDITOR": "Badge editor",
    "BADGE_FONTS": "Badge Fonts",
    "BADGE_SCANNING": "Badge scanning",
    "BADGE_SCANNING_FIELDS": "Badge scanning fields",
    "BASE_URL": "Base URL",
    "BASIC_REGISTRATION": "Basic Registration",
    "BEFORE": "Before",
    "BEFORE_REGISTRATIONS": "Before registrations",
    "BIDIRECTIONAL": "Bidirectional",
    "BLACK": "Black",
    "BODY": "Body",
    "BOOKING": "Booking",
    "BOOKING_DETAILS": "Booking details",
    "BOOKING_NOT_FOUND": "Booking not found",
    "BOOKING_START_OR_END_DIFFERS_FROM_ACTIVITY": "Booking start/end time differs from the activity start/end time",
    "BOTTOM_BAR": "Bottom bar",
    "BOTTOM_MENU": "Bottom menu",
    "BOUNCED": "Bounced",
    "BOUNCE_EMAIL": "Bounce email",
    "BREAKOFF_TIME": "Break-off time",
    "BREAK_OFF_TIME": "Break-off time",
    "BROWSER_ICON": "Browser icon",
    "BROWSE_STORAGE": "Browse storage",
    "BUDGET_MANAGEMENT": "Budget Management",
    "BUDGET_SPENDING": "Budget spending",
    "BULK_FIELD_UPDATE": "Bulk field update",
    "BUTTONS": "Buttons",
    "BUTTON_LEFT": "Standard button - Left",
    "BUTTON_LEFT_CUSTOM_1": "Custom button 1 - Left",
    "BUTTON_LEFT_CUSTOM_2": "Custom button 2 - Left",
    "BUTTON_MIDDLE": "Standard button - Middle",
    "BUTTON_MIDDLE_CUSTOM_1": "Custom button 1 - Middle",
    "BUTTON_MIDDLE_CUSTOM_2": "Custom button 2 - Middle",
    "BUTTON_RIGHT": "Standard button - Right",
    "BUTTON_RIGHT_CUSTOM_1": "Custom button 1 - Right",
    "BUTTON_RIGHT_CUSTOM_2": "Custom button 2 - Right",
    "BUYER_EMAIL": "Buyer email",
    "BUYER_FIRST_NAME": "Buyer first name",
    "BUYER_LAST_NAME": "Buyer last name",
    "CACHE_TIME": "Cache time",
    "CALENDAR": "Calendar",
    "CALENDAR_DISPLAY_FIELDS_HINT": "Fields used to display event",
    "CALENDAR_FIELDS_HINT": "Fields used to filter",
    "CALENDAR_ID": "Calendar id",
    "CALENDAR_URL": "Calendar url",
    "CALL_TO_ACTION": "Call to action",
    "CALL_TO_ACTION_LEFT_BUTTON": "Call to action - Left button",
    "CALL_TO_ACTION_RIGHT_BUTTON": "Call to action - Right button",
    "CAMPAIGN": "Campaign",
    "CAMPAIGNS": "Campaigns",
    "CAMPAIGNS_CREATE": "Add event email campaigns",
    "CAMPAIGNS_DELETE": "Delete event email campaigns",
    "CAMPAIGNS_READ": "View event email campaigns",
    "CAMPAIGNS_UPDATE": "Edit event email campaigns",
    "CAMPAIGN_ASSETS": "Campaign assets",
    "CAMPAIGN_CREATE": "Add event email campaigns",
    "CAMPAIGN_NAME": "Campaign name",
    "CANCEL": "Cancel",
    "CANCELLATION": "Cancellation",
    "CANCELLATION_EMAIL": "Cancellation email",
    "CANCELLATION_FINALIZED": "Cancellation finalized",
    "CANCELLATION_INITIATED": "Cancellation initiated",
    "CANCELLATION_TERMS": "Cancellation terms",
    "CANCELLATION_TERMS_EXAMPLE": "Cancellation within days prior to event: 15 - Percentage of cancellation cost: 70",
    "CANCELLATION_TERMS_EXAMPLE_EXPLANATION": "If you wanted to provide a 30% refund to participants that cancel their participation within 15 days before the event start date, then you would add a cancellation condition as follows:",
    "CANCELLATION_TERMS_FIELDS": "Cancellation terms fields",
    "CANCELLATION_WITHIN_DAYS_PRIOR_TO_EVENT": "Cancellation within days prior to event",
    "CANCELLATION_WORKFLOW": "Cancellation workflow",
    "CANCELLATION_WORKFLOWS": "Cancellation workflows",
    "CANCELLATION_WORKFLOW_EXPLANATION": "Manage cancellations from registered participants",
    "CANCELLATION_WORKFLOW_NAME": "Cancellation",
    "CANCELLED": "Cancelled",
    "CANCELLED_AND_REASON_FROM_COMPLETED_STAGE": "Custom stage name - cancelled participants which completed the cancellation reason form",
    "CANCELLED_STAGE_NAME": "Cancelled Stage Name",
    "CANCEL_EVENT": "Cancel event",
    "CANCEL_EVENT_CONFIRMATION_DIALOG_ARE_YOU_SURE": "If you continue all registered participants will be cancelled (and fully refunded, if applicable for paid events)",
    "CANCEL_EVENT_DIALOG_TITLE": "Cancel Event",
    "CANCEL_PARTICIPANT": "Cancel participant",
    "CANNOT_CONTAIN_SPACES_NOR_BE_EMPTY": "Cannot contain spaces nor be empty",
    "CANNOT_EDIT_EVENT": "Cannot edit event",
    "CANNOT_VALIDATE_CURRENT_PASSWORD": "Cannot validate current password",
    "CANT_LOAD_ALL_EMAIL_TEMPLATE_DATA": "Can't load all email template data",
    "CANT_LOAD_EMAIL_TEMPLATE_THEME": "Can't load email template theme",
    "CANT_LOAD_HEADER_AND_FOOTER_PAGES": "Can't load header and footer pages",
    "CANT_LOAD_THEMES": "Can't load themes",
    "CAN_LEAVE_EMPTY": "You can leave this field empty",
    "CAPACITY": "Capacity",
    "CAPACITY_MUST_BE_HIGHER_THAN_ZERO": "The capacity must be higher than 0",
    "CATEGORIES": "Categories",
    "CATEGORY": "Category",
    "CATEGORY_FIELD": "Category field",
    "CATEGORY_FIELDS": "Category fields",
    "CATEGORY_FIELD_VALUE": "Category field value",
    "CC": "Cc",
    "CHANGE_NAME": "Change name",
    "CHANGE_PASSWORD": "Change password",
    "CHANGE_STAGE": "Change stage",
    "CHANGE_THEME": "Change theme",
    "CHANGE_THE_STATE_OF_SELECTED_PARTICIPANTS_TO": "Change the state of the selected participant(s) to:",
    "CHANNEL_ID": "Channel ID",
    "CHART": "Chart",
    "CHART_TYPE": "Chart type",
    "CHART_TYPE_BAR": "Bar",
    "CHART_TYPE_DONUT": "Donut",
    "CHAT": "Chat",
    "CHAT_SETTINGS": "Chat settings",
    "CHECKIN_APP": "Checkin app",
    "CHECKLIST_MODULES": "Checklist Modules",
    "CHECKLIST_ONBOARDING": "Checklist Onboarding",
    "CHECK_IN_APP": "Check-in app",
    "CHOOSE_AN_EXISTING_WIDGET_DIALOG_TITLE": "Choose an existing widget",
    "CHOOSE_FIELD_TYPE": "Choose field type",
    "CHOOSE_LIST": "Choose list",
    "CHOOSE_MODULE": "Choose modules to be included in this event",
    "CHOOSE_MODULES_TO_COPY": "Choose modules to copy",
    "CHOOSE_PARTICIPANTS": "Choose participant(s)",
    "CHOOSE_SAVED_FILTER": "Choose saved filter",
    "CHOOSE_TEMPLATE_TO_CREATE_THE_EVENTS_IN_THE_SERIES": "Choose template to create the events in the series",
    "CITY": "City",
    "CLEAR_ALL": "Clear all",
    "CLEAR_CACHE": "Clear cache",
    "CLEAR_CACHE_SETTINGS": "Clear cache settings",
    "CLEAR_LOGS": "Clear logs",
    "CLEAR_SELECTION": "Clear selection",
    "CLICK_HERE": "Click here",
    "CLICK_TO_SELECT_ICON": "Click to select icon",
    "CLIENT_ID": "Client id",
    "CLIENT_SECRET": "Client secret",
    "CLOSE": "Close",
    "CLOSED_COMPLETED_ORDER": "Closed",
    "CLOSE_COMPLETE_ORDER": "Close",
    "CLOSE_ORDERS_AFTER_EXPORT": "Close orders after export",
    "CODE": "Code",
    "CODE_VALID": "Code valid",
    "COLLAPSE": "Collapse",
    "COLOR": "Color",
    "COLORED_TEXT_ABOVE": "Colored-text above",
    "COLORED_TEXT_BELOW": "Colored-text below",
    "COLUMNS": "Columns",
    "COLUMNS_MANAGER_SEARCH_ITEMS_HINT": "Matched items are highlighted in blue. Scroll down to find them, if needed.",
    "COLUMNS_TO_DISPLAY": "Columns to display",
    "COMMENT": "Comment",
    "COMPANY": "Company",
    "COMPANY_MANAGER": "Company manager",
    "COMPANY_NAME": "Company name",
    "COMPANY_SIGN_IN": "Company Sign in",
    "COMPARE_CURRENT_DATE_TIME_TO_DATE_TIME_FIELD": "Compare current date time to date time field",
    "COMPLETED": "Completed",
    "COMPLETED_STAGE_NAME": "Completed stage name",
    "COMPLETE_SETTINGS": "Complete settings",
    "COMPLETE_SETTINGS_TO_GENERATE_REPORT": "Settings need to be completed before generating a report",
    "COMPONENT": "Component",
    "COMPONENTS": "Components",
    "CONDITION": "Condition",
    "CONDITIONAL_FILTER": "Conditional filter",
    "CONDITIONS": "Conditions",
    "CONDITIONS_ADDED": "Conditions added",
    "CONFERENCE_ROOM": "Conference room",
    "CONFIGURATION": "Configuration",
    "CONFIGURE_DKIM": "Configure DKIM",
    "CONFIGURE_DKIM_DESCRIPTION": "Please complete your DKIM settings to ensure maximum email security",
    "CONFIGURE_DMARC": "Configure DMARC",
    "CONFIGURE_DMARC_DESCRIPTION": "Please complete your DMARC settings to ensure maximum email security",
    "CONFIGURE_EVENT_WORKFLOW_AUTOMATION_SETTINGS_WARNING": "Please configure the settings below and save. Only then you will be able to activate this workflow automation.",
    "CONFIGURE_INTEGRATION_SETTINGS_WARNING": "Please configure the settings below and save. Only then you will be able to activate the integration.",
    "CONFIGURE_PROFILES": "Configure profiles",
    "CONFIGURE_SPF": "Configure SPF",
    "CONFIGURE_SPF_DESCRIPTION": "Please complete your SPF settings to ensure maximum email security",
    "CONFIRMATION_EMAIL": "Confirmation email",
    "CONFIRM_REVERT_TO_FIX": "Please revert to the latest published version to sync the revision.",
    "CONFIRM_UPLOAD": "confirm upload",
    "CONTACT": "Contact",
    "CONTACTASSETS_CREATE": "Add email assets",
    "CONTACTASSETS_DELETE": "Delete email assets",
    "CONTACTASSETS_READ": "View email assets",
    "CONTACTASSETS_UPDATE": "Edit email assets",
    "CONTACTS": "Contacts",
    "CONTACTS_CAMPAIGN_SEND": "Send email campaigns to contacts",
    "CONTACTS_EMAIL_MARKETING": "Contacts email marketing",
    "CONTACTTEMPLATES_CREATE": "Add email template",
    "CONTACTTEMPLATES_DELETE": "Delete email template",
    "CONTACTTEMPLATES_PUBLISH": "Publish contacts email campaign templates",
    "CONTACTTEMPLATES_READ": "View email template",
    "CONTACTTEMPLATES_UPDATE": "Edit email template",
    "CONTACT_CAMPAIGNS_CREATE": "Add new email campaign",
    "CONTACT_CAMPAIGNS_DELETE": "Delete email campaign",
    "CONTACT_CAMPAIGNS_READ": "View email campaign",
    "CONTACT_CAMPAIGNS_SEND": "Send email campaigns to contacts",
    "CONTACT_CAMPAIGNS_UPDATE": "Edit email campaign",
    "CONTACT_DETAILS": "Contact details",
    "CONTACT_DOES_NOT_EXIST_ANYMORE": "Contact does not exist anymore",
    "CONTACT_EMAIL": "Contact email",
    "CONTACT_FIELD": "Contact field",
    "CONTACT_FIELDS": "Contact field",
    "CONTACT_FIELDS_CREATE": "Add contact field",
    "CONTACT_FIELDS_DELETE": "Delete contact field",
    "CONTACT_FIELDS_READ": "View contact field",
    "CONTACT_FIELDS_SCOPES": "Contact Fields",
    "CONTACT_FIELDS_UPDATE": "Edit contact field",
    "CONTACT_FIRST_NAME": "Contact first name",
    "CONTACT_ID": "Contact ID",
    "CONTACT_LAST_NAME": "Contact last name",
    "CONTACT_MAPPING": "Contact mapping",
    "CONTACT_MODULE_NAME": "Contact module name",
    "CONTACT_PROCESSES": "Contact processes",
    "CONTACT_TEMPLATES_CREATE": "Contact templates create",
    "CONTACT_TEXT_FIELD": "Contact text field",
    "CONTAINS": "Contains",
    "CONTENT": "Content",
    "CONTENT_IS_BEING_EDITED_IN_OTHER": "Content is being edited in other place.",
    "CONTENT_PAGE": "Content page",
    "CONTENT_PAGES": "Content pages",
    "CONTENT_SETTINGS": "Content settings",
    "CONTENT_TYPE": "Content type",
    "CONTINUE": "Continue",
    "CONTINUE_AFTER_END_OF_EVENT_IN_DAYS": "Continue after end of event in (days)",
    "CONTINUE_AFTER_SECONDS": "Continue after second(s)",
    "CONTINUE_REGISTRATION": "Continue registration",
    "CONTINUE_REGISTRATION_AFTER_CANCELLATION": "Continue registration after cancellation",
    "CONTINUE_REGISTRATION_AFTER_DECLINE": "Continue registration",
    "CONTINUE_WITH_SURVEY_OR_OTHER_WORKFLOWS": "Continue with survey or other workflows",
    "CONTINUE_WITH_WORKFLOW": "Continue with workflow",
    "COPIED": "Copied",
    "COPY": "Copy",
    "COPY_AS_TEMPLATE": "Create template of this event",
    "COPY_DESIGN_FROM_AZAVISTA_DESIGN_LIBRARY": "Copy design from Azavista Design Library",
    "COPY_EVENT_AS_TEMPLATE": "Copy event as template",
    "COPY_EVENT_DATES": "Copy event dates",
    "COPY_EVENT_END_DATE_TIME_TO_THIS_FIELD": "Copy event end date-time to this date field",
    "COPY_EVENT_START_DATE_TIME_TO_THIS_FIELD": "Copy event start date-time to this date field",
    "COPY_EVENT_TEXT_FIELD_TO_PARTICIPANT": "Copy event text field to participant text field",
    "COPY_ITEM_FROM_EXTERNAL_CLUSTER": "Copy item from external cluster",
    "COPY_QR_CODE": "Copy QR code",
    "COPY_TEAMS": "Copy teams",
    "COPY_TEAMS_ASSIGNEE": "Copy teams from assignee",
    "COPY_TO_CLIPBOARD": "Copy to clipboard",
    "COPY_URL": "Copy URL",
    "COPY_USERS_ASSIGNEE": "Copy users from assignee",
    "COUNTDOWN_CLOCK_WIDGET_DESCRIPTION": "Countdown until the event start date",
    "COUNTDOWN_CLOCK_WIDGET_EXAMPLE": "Days left until Annual Conference 2021",
    "COUNTDOWN_CLOCK_WIDGET_TITLE": "Countdown clock",
    "COUNTDOWN_TIMER": "Countdown timer",
    "COUNTRY": "Country",
    "COUNT_AS": "Count as",
    "COUNT_ITEMS_SELECTED": "{{count}} item(s) selected",
    "COUNT_SELECT_FIELD": "Count select field",
    "COUNT_TYPE": "Count type",
    "CREATE": "Create",
    "CREATED": "Created",
    "CREATED_AT": "Created at",
    "CREATED_BY": "Created by",
    "CREATED_OR_UPDATED": "Created or updated",
    "CREATE_ACCOUNT": "Create account",
    "CREATE_ACTIVITY_CONDITION": "Create activity condition",
    "CREATE_ACTIVITY_GROUP": "Create activity group",
    "CREATE_AMENITY": "Create amenity",
    "CREATE_API_CLIENT_SECRETS": "API Client secrets",
    "CREATE_CAMPAIGN": "Create campaign",
    "CREATE_CATEGORY": "Create category",
    "CREATE_CERTIFICATES": "Create certificates",
    "CREATE_CERTIFICATE_DOCUMENT": "Create Certificate/ Document",
    "CREATE_CUSTOM_BADGE": "Create Custom Badge",
    "CREATE_DASHBOARD": "Create dashboard",
    "CREATE_EMAIL_TEMPLATE": "Create email template",
    "CREATE_EVENT": "Create event",
    "CREATE_EVENT_APP": "Create event app",
    "CREATE_EVENT_DESIGN": "Create event design",
    "CREATE_EVENT_DESIGN_DESCRIPTION": "Import or create new themes and templates that are the perfect fit for your branding",
    "CREATE_EVENT_FROM_SCRATCH": "Create event from scratch",
    "CREATE_EVENT_FROM_TEMPLATE": "Create event from template",
    "CREATE_EVENT_SEQUENCE": "Create event sequence",
    "CREATE_EVENT_SERIES": "Create event series",
    "CREATE_EVENT_URL": "Create event URL",
    "CREATE_FIELD": "Create field",
    "CREATE_FLOOR_PLAN": "Create floor plan",
    "CREATE_FROM_PRESET": "Create from Event Library",
    "CREATE_FROM_SCRATCH": "Create from scratch",
    "CREATE_FROM_TEMPLATE": "Create from template",
    "CREATE_GENERIC_WORKFLOW": "Create generic workflow",
    "CREATE_INTEGRATION": "Create Integration",
    "CREATE_LOCATION": "Create location",
    "CREATE_MEDIUM": "Create medium",
    "CREATE_NEW": "Create new",
    "CREATE_NEW_ACTIVITY": "Create new activity",
    "CREATE_NEW_API_CLIENT": "Create new API client",
    "CREATE_NEW_CANCELLATION_TERMS": "Create new cancellation terms",
    "CREATE_NEW_CONTACT": "Create new contact",
    "CREATE_NEW_DEPENDENCY": "Create new dependency",
    "CREATE_NEW_DISCOUNT": "Create new discount",
    "CREATE_NEW_EMAIL_CAMPAIGN": "Create new email campaign",
    "CREATE_NEW_EVENT": "Create a new event",
    "CREATE_NEW_FILTER": "Create new filter",
    "CREATE_NEW_GLOBAL_REPORT": "Create new global report",
    "CREATE_NEW_INTEGRATION": "Create Integration",
    "CREATE_NEW_ORGANIZATION": "Create a new organization",
    "CREATE_NEW_PAGE": "Create new page",
    "CREATE_NEW_PRODUCT": "Create Product",
    "CREATE_NEW_PROFILE_PAGE": "Create new profile page",
    "CREATE_NEW_REPORT": "Create new report",
    "CREATE_NEW_ROLE": "Create a new role",
    "CREATE_NEW_TAX": "Create new tax",
    "CREATE_NEW_TEAM": "Create a new team",
    "CREATE_NEW_USER": "Create a new user",
    "CREATE_NEW_WORKFLOW": "Create new workflow",
    "CREATE_PARTICIPANT_ACCOUNT_CREATION_EMAIL": "Create account-creation email for participant",
    "CREATE_PARTICIPANT_CONFIRMATION_CODE_EMAIL": "Create confirmation-code email for participant",
    "CREATE_PARTICIPANT_LOGIN_LINK_EMAIL": "Create login-link email for participant",
    "CREATE_PARTICIPANT_PASSWORD_RESET_EMAIL": "Create password-reset email for participant",
    "CREATE_PRODUCT_GROUP": "Create Product Group",
    "CREATE_PROJECT": "Create new project",
    "CREATE_PROJECT_FROM_PRESET": "Create project from preset",
    "CREATE_PROJECT_FROM_TEMPLATE": "Create project from template",
    "CREATE_PROJECT_TEMPLATE": "Create project template",
    "CREATE_ROOM": "Create room",
    "CREATE_SOURCE": "Create source",
    "CREATE_TASK": "Create new task",
    "CREATE_TEMPLATE_FROM_PROJECT": "Create template from project",
    "CREATE_VERSION": "Create version",
    "CREATE_VIEW": "Create view",
    "CREATE_WORKBLOCK": "Create workblock",
    "CREATE_WORKBLOCK_NAME": "Create workblock",
    "CREATION_DATE": "Creation date",
    "CREATION_OF_THE_EVENT_DID_NOT_COMPLETE_SUCCESSFULLY_AND_IT_WAS_DELETED": "Creation of the event did not complete successfully and it was deleted",
    "CREATOR_TYPE": "Creator type",
    "CREDENTIALS_EXPIRED": "Credentials expired",
    "CRITERIA": "Criteria",
    "CRM_CAMPAIGN_SCOPES": "Email marketing campaigns",
    "CRM_COMMUNICATION": "CRM Communication",
    "CRM_CONTACTS": "CRM Contacts",
    "CRM_CONTACTS_CAMPAIGN_SEND": "Send email campaigns to contacts",
    "CRM_CREATE": "Add contacts and organizations",
    "CRM_DASHBOARD": "CRM Dashboard",
    "CRM_DELETE": "Delete contacts and organizations",
    "CRM_EDIT": "Edit contacts and organizations",
    "CRM_EDITOR": "CRM Edit",
    "CRM_EMAIL_ASSET_SCOPES": "Email marketing assets",
    "CRM_EMAIL_SCOPES": "Email marketing templates",
    "CRM_EXPORT": "Export contacts and organizations",
    "CRM_EXPORTS": "CRM extra capabilities",
    "CRM_EXT_SCOPES": "CRM extra capabilities",
    "CRM_FIELD": "CRM field",
    "CRM_ORGANIZATIONS": "CRM Organizations",
    "CRM_READ": "View contacts and organizations",
    "CRM_READER": "CRM Read",
    "CRM_SCOPES": "CRM capabilities",
    "CRM_STATUS": "CRM status",
    "CRM_VIEW": "CRM Views",
    "CROPPING_MANDATORY": "Cropping mandatory",
    "CURRENCY": "Currency",
    "CURRENT_PASSWORD": "Current password",
    "CURRENT_STATUS": "Current status",
    "CUSTOM": "Custom",
    "CUSTOM_FONTS": "Custom fonts",
    "CUSTOM_FONT_NAME": "Custom Font Name",
    "CUSTOM_FONT_NAME_EMPTY_ERROR": "Please enter a valid font name.",
    "CUSTOM_FONT_NAME_INVALID_ERROR": "Font name must end with .ttf and use valid characters.",
    "CUSTOM_FONT_NAME_MAX_LENGTH_ERROR": "Font name can be up to 19 characters.",
    "CUSTOM_FONT_NAME_MAX_LENGTH_MESSAGE": "Please rename the font so the font name size is decreased otherwise it cannot be loaded on the badge printers",
    "CUSTOM_HEADING_1": "Custom Heading 1",
    "CUSTOM_HEADING_2": "Custom Heading 2",
    "CUSTOM_HEADING_3": "Custom Heading 3",
    "CUSTOM_HEADING_4": "Custom Heading 4",
    "CUSTOM_PROCESSES": "Custom processes",
    "CUSTOM_PROFILE": "Custom Profile",
    "CYBERSOURCE_FIELD": "Cybersource field",
    "DAILY": "Daily",
    "DASHBOARD": "Dashboard",
    "DATA_SOURCE_TEAMS": "Data source teams",
    "DATE": "Date",
    "DATETIME_FORMAT": "Datetime format",
    "DATE_CREATED": "Date created",
    "DATE_FIELD": "Date field",
    "DATE_FORMAT": "Date format",
    "DATE_TIME_FORMAT": "Date-time format",
    "DAY": "Day",
    "DAYS": "Days",
    "DEADLINE_FOR_NEW_REGISTRATIONS": "Deadline for new registrations",
    "DECLINE": "Decline",
    "DECLINED": "Declined",
    "DECLINED_AND_REASON_FROM_COMPLETED_STAGE": "Declined with reason",
    "DECLINED_STAGE_NAME": "Declined stage name",
    "DECLINE_EMAIL": "Decline email",
    "DECLINE_FINALIZED": "Decline finalized",
    "DECLINE_INITIATED": "Decline initiated",
    "DECLINE_LINK_BUTTON": "Decline link button",
    "DECLINE_WORKFLOW": "Decline workflow",
    "DECLINE_WORKFLOW_EXPLANATION": "Manage declines from invited participants",
    "DECLINE_WORKFLOW_NAME": "Decline",
    "DEFAULT": "Default",
    "DEFAULT_EMAIL": "Default email",
    "DEFAULT_EMPTY_VALUE": "Default empty value",
    "DEFAULT_FIELD": "Default field",
    "DEFAULT_FIELDS": "Default fields",
    "DEFAULT_PAGE": "Default page",
    "DEFAULT_STAGE": "Default stage",
    "DEFAULT_VALUE": "Default value",
    "DELETE": "Delete",
    "DELETED": "Deleted",
    "DELETED_VALUE": "Deleted value",
    "DELETE_ACTIVITY_CONDITIONS_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected activity conditions?",
    "DELETE_ACTIVITY_CONDITIONS_DIALOG_TITLE": "Delete activity conditions",
    "DELETE_ACTIVITY_GROUPS_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected activity groups?",
    "DELETE_ACTIVITY_GROUPS_DIALOG_TITLE": "Delete activity groups",
    "DELETE_AMENITY_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected amenity(ies)?",
    "DELETE_AMENITY_DIALOG_TITLE": "Delete amenity",
    "DELETE_API_CLIENT_CONFIRMATION_DIALOG_TITLE": "Delete API client",
    "DELETE_API_CLIENT_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected API client?",
    "DELETE_BADGE_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected badge?",
    "DELETE_BADGE_DIALOG_TITLE": "Delete badge",
    "DELETE_CAMPAIGN_ASSET_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected campaign asset?",
    "DELETE_CAMPAIGN_ASSET_CONFIRMATION_DIALOG_TITLE": "Delete campaign asset",
    "DELETE_CANCELLATION_TERMS_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to archive the selected cancellation terms?",
    "DELETE_CANCELLATION_TERMS_DIALOG_TITLE": "Delete Cancellation Terms",
    "DELETE_CATEGORY_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected categories?",
    "DELETE_CATEGORY_DIALOG_TITLE": "Delete categories",
    "DELETE_CONTACT_CONFIRMATION_DIALOG_TITLE": "Archive contact",
    "DELETE_CONTACT_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected contact?",
    "DELETE_DOCUMENTS_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected documents",
    "DELETE_DOCUMENTS_CONFIRMATION_DIALOG_TITLE": "Delete documents",
    "DELETE_EMAIL_CAMPAIGN_TYPE_CONFIRMATION_DIALOG_TITLE": "Delete email campaign type",
    "DELETE_EMAIL_CAMPAIGN_TYPE_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected email campaign type?",
    "DELETE_EVENT_ACTIVITY_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected event activity?",
    "DELETE_EVENT_ACTIVITY_DIALOG_TITLE": "Delete event activity",
    "DELETE_EVENT_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected event?",
    "DELETE_EVENT_CONFIRMATION_DIALOG_TITLE": "Delete event",
    "DELETE_EVENT_EMAIL_CAMPAIGN_CONFIRMATION_DIALOG_TITLE": "Delete email campaign",
    "DELETE_EVENT_EMAIL_CAMPAIGN_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected email campaign?",
    "DELETE_EVENT_EMAIL_CAMPAIGN_SCHEDULE_CONFIRMATION_DIALOG_TITLE": "Delete campaign schedule",
    "DELETE_EVENT_EMAIL_CAMPAIGN_SCHEDULE_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected campaign schedule?",
    "DELETE_EVENT_PARTICIPANT_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected event participant?",
    "DELETE_EVENT_PARTICIPANT_DIALOG_TITLE": "Delete event participant",
    "DELETE_EVENT_ROOM_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected event room(s)?",
    "DELETE_EVENT_ROOM_DIALOG_TITLE": "Delete event room",
    "DELETE_EVENT_SERIES_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected event series?",
    "DELETE_EVENT_SERIES_CONFIRMATION_DIALOG_TITLE": "Delete event series",
    "DELETE_EVENT_WORKFLOW_AUTOMATION_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected workflow automation?",
    "DELETE_EVENT_WORKFLOW_AUTOMATION_CONFIRMATION_DIALOG_TITLE": "Delete workflow automation",
    "DELETE_EXTERNAL_CRM_SYSTEM_OBJECT_MAPPING_DIALOG_DESCRIPTION": "Are you sure you want to delete the selected external CRM system object mapping item?",
    "DELETE_EXTERNAL_CRM_SYSTEM_OBJECT_MAPPING_DIALOG_TITLE": "Delete object mapping",
    "DELETE_FIELD_CONFIRMATION_DIALOG_TITLE": "Archive field(s)",
    "DELETE_FIELD_DIALOG_ARE_YOU_SURE": "Are you sure that you want to archive the selected field(s)",
    "DELETE_FLOOR_PLAN_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected floor plan(s) ?",
    "DELETE_FLOOR_PLAN_DIALOG_TITLE": "Delete floor plan",
    "DELETE_INTEGRATION_CONFIRMATION_DIALOG_TITLE": "Delete Integration",
    "DELETE_INTEGRATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected integration(s)?",
    "DELETE_LINK_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected link(s)?",
    "DELETE_LINK_DIALOG_TITLE": "Delete link(s)",
    "DELETE_LOCATIONS_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected location(s)?",
    "DELETE_LOCATION_DIALOG_TITLE": "Delete location",
    "DELETE_ORGANIZATION_CONFIRMATION_DIALOG_TITLE": "Archive organization",
    "DELETE_ORGANIZATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to archive the selected organization?",
    "DELETE_PROCESS_CONFIRMATION_DIALOG_TITLE": "Delete process",
    "DELETE_PROCESS_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected process?",
    "DELETE_PRODUCT_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected product(s)?",
    "DELETE_PRODUCT_DIALOG_TITLE": "Delete product(s)",
    "DELETE_PRODUCT_GROUP_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected product group(s)?",
    "DELETE_PRODUCT_GROUP_DIALOG_TITLE": "Delete Product Group(s)",
    "DELETE_PROFILE_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete selected profiles?",
    "DELETE_PROFILE_DIALOG_TITLE": "Delete profile",
    "DELETE_PROJECT_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected project(s)?",
    "DELETE_PROJECT_DIALOG_TITLE": "Delete projects",
    "DELETE_PROJECT_TEMPLATE_DIALOG_ARE_YOU_SURE": "Are you sure to delete project template(s)",
    "DELETE_PROJECT_TEMPLATE_DIALOG_TITLE": "Delete project template(s)",
    "DELETE_ROLE_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected role?",
    "DELETE_ROLE_CONFIRMATION_DIALOG_TITLE": "Delete role",
    "DELETE_ROOMS_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected room(s)?",
    "DELETE_ROOMS_DIALOG_TITLE": "Delete rooms",
    "DELETE_ROOM_BOOKING_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected room booking(s)?",
    "DELETE_ROOM_BOOKING_DIALOG_TITLE": "Delete room booking(s)",
    "DELETE_STAGE_CONFIRMATION_DIALOG_TITLE": "Delete stage",
    "DELETE_STAGE_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected stage?",
    "DELETE_SYSTEM_EMAILS": "Delete system email(s)",
    "DELETE_SYSTEM_EMAILS_ARE_YOU_SURE": "Are you sure to delete the selected system email(s)?",
    "DELETE_TASKS": "Delete task(s)",
    "DELETE_TASKS_ARE_YOU_SURE": "Are you sure to delete task(s)?",
    "DELETE_TAX_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to archive the selected tax(es)?",
    "DELETE_TAX_CONFIRMATION_DIALOG_TITLE": "Archive tax(es)",
    "DELETE_TEAM_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected team?",
    "DELETE_TEAM_CONFIRMATION_DIALOG_TITLE": "Delete team",
    "DELETE_THEME_CONFIRMATION_DIALOG_TITLE": "Delete theme",
    "DELETE_THEME_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected theme?",
    "DELETE_USER_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected user?",
    "DELETE_USER_CONFIRMATION_DIALOG_TITLE": "Delete user",
    "DELETE_UTM_PARAMETER_DIALOG_ARE_YOU_SURE": "Are you sure you want to delete the selected UTM parameter(s)?",
    "DELETE_UTM_PARAMETER_DIALOG_TITLE": "Delete UTM parameter(s)",
    "DELETE_WEBSITE_PAGE_CONFIRMATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected page?",
    "DELETE_WEBSITE_PAGE_DIALOG_TITLE": "Delete page",
    "DELETE_WEB_DEPENDENCY_DIALOG_ARE_YOU_SURE": "Are you sure that you want to delete the selected web dependency?",
    "DELETE_WEB_DEPENDENCY_DIALOG_TITLE": "Delete web dependency",
    "DELETE_WORKFLOW_BLOCK": "Delete Workflow block",
    "DELETE_WORKFLOW_BLOCK_CONFIRMATION": "Are you sure that you want to delete the selected Workflow block?",
    "DELIVERY_DATE": "Delivery date",
    "DENIED": "Denied",
    "DENIED_WORKFLOW": "Denied workflow",
    "DEPARTED_AT": "Departed at",
    "DEPARTMENT": "Department",
    "DEPENDENCIES": "Dependencies",
    "DEPENDENCY": "Dependency",
    "DESCRIPTION": "Description",
    "DESIGN": "Design",
    "DESIGN_EVENT": "Design event",
    "DESIGN_PAGE": "Design page",
    "DESIGN_SETTINGS": "Design settings",
    "DESIGN_TEMPLATE": "Design template",
    "DETAILS": "Details",
    "DETAIL_FIELDS": "Detail fields",
    "DEVICE": "Device",
    "DIFFERENCE": "Difference",
    "DIFFERENT_APP_SETTINGS_FOR": "Different app settings for",
    "DISABLE": "Disable",
    "DISABLED": "Disabled",
    "DISABLED_EMAIL_DOMAINS": "Disabled email domains",
    "DISABLE_FORMS": "Disable forms",
    "DISABLE_MANUAL_STAGE_CHANGE": "Disable manual stage change",
    "DISABLE_SUBMIT_BUTTON_UNTIL_END_OF_VIDEO": "Disable submit button until the end of the video",
    "DISCOUNT": "Discount",
    "DISCOUNTS": "Discounts",
    "DISCOUNT_CODE": "Discount code",
    "DISCOUNT_STATUS_ACTIVE": "Active",
    "DISCOUNT_STATUS_INACTIVE": "Inactive",
    "DISPLAY": "Display",
    "DISPLAY_DISCOUNT_FIELD": "Display Discount Field",
    "DISPLAY_EMAIL_STATUS": "Display email status",
    "DISPLAY_FIELDS_SEARCH": "Display fields search",
    "DISPLAY_LABEL": "Display label",
    "DISPLAY_LOGOUT_MENU": "Display Logout menu",
    "DISPLAY_ONLY_ARRIVED_PARTICIPANTS": "Display only arrived participants",
    "DISPLAY_OPTION": "Display option",
    "DISPLAY_STAGES": "Display stages",
    "DISPLAY_STATUSES": "Display statuses",
    "DIVIDER": "Divider",
    "DOCUMENT": "Document",
    "DOCUMENTS": "Documents",
    "DOCUMENT_FIELD": "Document field",
    "DOCUMENT_LINK_BUTTON": "Document link button",
    "DOCUMENT_NAME": "Document name",
    "DOES_NOT_CONTAIN": "Does not contain",
    "DONE": "Done",
    "DONT_HAVE_ACCOUNT_YET": "Don't have an account yet?",
    "DOTS_PER_MM": "Dots per mm",
    "DOUBLE_SIDED": "Double Sided",
    "DOWNLOAD": "Download",
    "DO_NOT_SEND_ANY_EMAIL": "Do not send any email",
    "DO_NOT_SEND_TO_CURRENT_AUDIENCE_MEMBERS": "Do not send this email to people who already received it or are scheduled to receive it",
    "DO_NOT_USE_PARTICIPANT_TEAMS": "Do not use participant teams",
    "DO_UNIQUE_EMAIL_VALIDATION": "Validation on unique email addresses - each participant must have a unique email address",
    "DO_YOU_WANT_TO_SAVE_SETTINGS": "Do you want to save settings?",
    "DRAFT": "Draft",
    "DROP_YOUR_FILE_HERE_TO_UPLOAD": "Drop your file here to upload",
    "DUE_AT": "Date due",
    "DUE_TO_INSUFFICIENT_PERMISSIONS_THE_CHANGES_WILL_NOT_BE_SAVED": "Due to insufficient permissions, the changes will not be saved",
    "DUPLICATE": "Duplicate",
    "DUPLICATES": "Duplicates",
    "DUPLICATE_EMAIL": "Duplicate email",
    "DUPLICATE_EMAILS_ALLOWED": "Duplicate emails allowed",
    "DUPLICATE_EMAIL_CAMPAIGN": "Duplicate email campaign",
    "DUPLICATE_EVENT": "Duplicate event",
    "DUPLICATE_EVENT_TEMPLATE": "Duplicate event template",
    "DUPLICATE_EXISTING_DASHBOARD": "Duplicate existing dashboard",
    "DUPLICATE_FOOTER": "Duplicate footer",
    "DUPLICATE_HEADER": "Duplicate header",
    "DUPLICATE_PROJECT": "Duplicate project",
    "DUPLICATE_PROJECT_TEMPLATE": "Duplicate project template",
    "DUPLICATE_V4": "Duplicate 4.0 Preview",
    "DUPLICATE_WEB_PAGE": "Duplicate web page",
    "DURATION": "Duration",
    "DURATION_DAYS": "Duration(days)",
    "DURING_THE_TIME_PERIOD_THIS_PROCESS_WAS_PAUSED_MESSAGES_HAVE_BEEN_SAVED": "During the time period this process was paused, messages have been saved",
    "EDIT": "Edit",
    "EDITABLE_FIELDS": "Editable fields",
    "EDITOR": "Editor",
    "EDIT_BADGE": "Edit badge",
    "EDIT_CATEGORY": "Edit Category",
    "EDIT_CONFIGURATION": "Edit configuration",
    "EDIT_DASHBOARD": "Edit dashboard",
    "EDIT_DETAILS": "Edit Details",
    "EDIT_EMAIL": "Edit email",
    "EDIT_FIELD": "Edit field",
    "EDIT_FILTER": "Edit filter",
    "EDIT_MODE": "Edit mode",
    "EDIT_PROCESS": "Edit process",
    "EDIT_PROFILE_PAGE": "Edit profile page {{profilePageName}}",
    "EDIT_PROJECT": "Edit project",
    "EDIT_STAGE": "Edit stage",
    "EDIT_TEMPLATE": "Edit template",
    "EDIT_THEME": "Edit theme",
    "EDIT_VIEW": "Edit view",
    "EDIT_WEBSITE_MENU": "Edit website menu",
    "ELSE": "Else",
    "EMAIL": "Email",
    "EMAILS": "Emails",
    "EMAILTEMPLATES_CREATE": "Create event email templates",
    "EMAILTEMPLATES_DELETE": "Delete event email templates",
    "EMAILTEMPLATES_PUBLISH": "Publish event email templates",
    "EMAILTEMPLATES_READ": "View event email templates",
    "EMAILTEMPLATES_UPDATE": "Edit event email templates",
    "EMAIL_ADDRESS": "Email address",
    "EMAIL_BUILDER": "Email builder",
    "EMAIL_CAMPAIGN": "Email campaign",
    "EMAIL_CAMPAIGNS": "Email campaigns",
    "EMAIL_CAMPAIGN_DELIVERY_WIDGET_DESCRIPTION": "Overview of an email campaign's delivery",
    "EMAIL_CAMPAIGN_DELIVERY_WIDGET_EXAMPLE": "Email campaign delivery based on the delivery status",
    "EMAIL_CAMPAIGN_DELIVERY_WIDGET_TITLE": "Email Campaign Delivery",
    "EMAIL_CAMPAIGN_DETAILS": "Campaign details",
    "EMAIL_CAMPAIGN_SCOPES": "Event email campaigns",
    "EMAIL_CAMPAIGN_SEND_SCOPES": "Event email campaigns extra",
    "EMAIL_CAMPAIGN_SUBSCRIPTIONS": "Email campaign subscriptions",
    "EMAIL_CAMPAIGN_TYPE": "Email campaign type",
    "EMAIL_CAMPAIGN_TYPES": "Email campaign types",
    "EMAIL_CAMPAIGN_WHEN_STAGE_SELECTED": "Email campaign to be sent when stage is selected",
    "EMAIL_CODE": "Email code",
    "EMAIL_DETAILS": "Email details",
    "EMAIL_FIELD": "Email field",
    "EMAIL_FOOTER": "Email footer",
    "EMAIL_FROM_EVENT_FIELD": "Email to event email field",
    "EMAIL_FROM_FIELD": "Email to participant email field",
    "EMAIL_HEADER": "Email header",
    "EMAIL_INFORMATION": "Email information",
    "EMAIL_MARKETING": "Email marketing",
    "EMAIL_MODERATOR": "Email moderator",
    "EMAIL_NAME": "Email name",
    "EMAIL_PARTICIPANTS": "Email participants",
    "EMAIL_PREVIEW": "Email preview",
    "EMAIL_PROVIDER": "Email provider",
    "EMAIL_SEND": "Send event email campaigns",
    "EMAIL_SENT": "Email sent",
    "EMAIL_SPEAKER": "Email speaker",
    "EMAIL_STATUS": "Email status",
    "EMAIL_SUBJECT": "Email subject",
    "EMAIL_SUBSCRIPTION_UPDATED_TRIGGER": "Email subscription updated trigger",
    "EMAIL_TEMPLATE": "Email template",
    "EMAIL_TEMPLATES": "Email templates",
    "EMAIL_TEMPLATES_SCOPES": "Event email templates",
    "EMAIL_TEMPLATE_NOT_PUBLISHED": "The email template for this campaign has not been published yet",
    "EMAIL_TEMPLATE_SCOPES": "Event email templates",
    "EMAIL_THEMES": "Email themes",
    "EMAIL_TO_EVENT_EMAIL_FIELD": "Email to event email field",
    "EMAIL_TO_INFORM_PARTICIPANT_IS_ON_WAITINGLIST": "Email to inform participant is on waiting list",
    "EMAIL_TO_INFORM_PARTICIPANT_SPOT_IS_AVAILABLE": "Email to inform participant spot is available",
    "EMAIL_TO_PARTICIPANT": "Email to participant",
    "EMAIL_TRIGGER": "Email trigger",
    "EMPTY": "Empty",
    "EMPTY_FIELDS_ARE_NOT_ALLOWED": "Empty fields are not allowed",
    "EMPTY_OR_HEX": "You can leave this field empty or it must respect the hexadecimal format (e.g. #32A852)",
    "EMPTY_OR_URL_HTTPS": "You can leave this field empty or the URL must start with https://",
    "EMPTY_SHORT_NAMES_ARE_NOT_ALLOWED": "Empty short names are not allowed",
    "EMPTY_VALUE": "Empty value",
    "ENABLED": "Enabled",
    "ENABLE_EVENT_OFFLINE_DATE": "Enable Event Offline Date",
    "ENABLE_EVENT_PUBLICATION_DATE": "Enable event publication date",
    "ENABLE_GROUP_CHAT_MODERATION": "Enable Group Chat Moderation",
    "ENABLE_LAST_REGISTRATION_DATE": "Enable last registration date",
    "ENABLE_MODERATION": "Enable moderation",
    "ENABLE_QUESTIONS_MODERATION": "Enable Questions Moderation",
    "ENABLE_STANDALONE_APP": "Enable standalone app",
    "END": "End",
    "ENDPOINT": "Endpoint",
    "ENDS": "Ends",
    "END_DATE_FIELD": "End date field",
    "END_TIME": "End time",
    "ENGAGEMENT": "Engagement",
    "ENGAGEMENT_APP": "Engagement app",
    "ENGAGEMENT_APP_BUTTON": "Engagement app button",
    "ENGAGEMENT_APP_CSS": "Engagement app CSS",
    "ENGAGEMENT_APP_GENERIC_SETTINGS": "Engagement app generic settings",
    "ENGAGEMENT_APP_SETTINGS": "Engagement app settings",
    "ENGAGEMENT_SEQUENCE": "Engagement sequence",
    "ENGAGEMENT_SETTINGS": "Engagement settings",
    "ENTER_ALL_REQUIRED_FIELDS": "Enter all required fields",
    "ENTER_NAME_WITHOUT_HTTPS": "Enter the domain name without https:// (e.g. events.companyname.com)",
    "ENTER_TEXT": "Enter text",
    "ENTITY_UPDATED": "Object changed",
    "ENTITY_UPDATED_TRIGGER": "Object changed trigger",
    "ENVIRONMENT": "Environment",
    "ERROR": "Error",
    "ERROR_MESSAGE": "Error message",
    "ERROR_ROW_COUNT": "Error row count",
    "EVENT": "Event",
    "EVENTASSETS_CREATE": "Add assets",
    "EVENTASSETS_DELETE": "Delete assets",
    "EVENTASSETS_READ": "View assets",
    "EVENTASSETS_UPDATE": "Edit assets",
    "EVENTDOCUMENTS_CREATE": "Add event documents",
    "EVENTDOCUMENTS_DELETE": "Delete event documents",
    "EVENTDOCUMENTS_READ": "View event documents",
    "EVENTDOCUMENTS_UPDATE": "Edit event documents",
    "EVENTS": "Events",
    "EVENTS_ASSIGNED": "Events assigned",
    "EVENTS_BY_EVENT_TYPE_WIDGET_DESCRIPTION": "Events grouped by any event fields",
    "EVENTS_BY_EVENT_TYPE_WIDGET_EXAMPLE": "All events by location",
    "EVENTS_BY_EVENT_TYPE_WIDGET_TITLE": "Events grouped by",
    "EVENTS_CANCEL": "Cancel events",
    "EVENTS_COPY": "Copy events",
    "EVENTS_CREATE": "Add events",
    "EVENTS_DELETE": "Delete events",
    "EVENTS_FINANCIAL": "Manage event tickets and products",
    "EVENTS_LIST": "Events list",
    "EVENTS_READ": "View events",
    "EVENTS_UNASSIGNED": "Event(s) are unassigned",
    "EVENTS_UPDATE": "Edit events",
    "EVENTS_UPDATE_SETTINGS": "Update event settings",
    "EVENTS_VIEW": "Event views",
    "EVENTS_WORKFLOW": "Event workflows",
    "EVENTTEMPLATES_CREATE": "Add templates",
    "EVENTTEMPLATES_DELETE": "Delete templates",
    "EVENTTEMPLATES_EDIT": "Edit templates",
    "EVENTTEMPLATES_READ": "View templates",
    "EVENTTEMPLATES_UPDATE": "Edit templates",
    "EVENT_ACTIVITIES": "Manage sessions",
    "EVENT_APP": "Event app",
    "EVENT_APP_ACCESS": "Event App Access",
    "EVENT_APP_BUTTON": "Event App button",
    "EVENT_APP_MODULE": "Event app module",
    "EVENT_APP_MODULE_ENTITY": "Event app module entity",
    "EVENT_APP_NAME": "Event App name",
    "EVENT_APP_PAGE": "Event app page",
    "EVENT_APP_PUSH_MESSAGES": "Event App push messages",
    "EVENT_APP_SETTINGS": "Event app settings",
    "EVENT_APP_SETTINGS_DO_YOU_WANT_TO_SAVE_DIALOG_SAVE_OR_CANCEL": "Do you want to save the changes made to current event app settings?",
    "EVENT_APP_SETTINGS_DO_YOU_WANT_TO_SAVE_DIALOG_TITLE": "Event app settings",
    "EVENT_APP_URL": "EventApp URL",
    "EVENT_ARCHIVE": "Event archive",
    "EVENT_ASSETS": "Event assets",
    "EVENT_CANCELLATION_WORKFLOW_EXPLANATION": "Event cancellation: manage the cancellation of the whole event",
    "EVENT_CANCELLATION_WORKFLOW_NAME": "Event cancellation",
    "EVENT_CANCELLED_SEQUENCE": "Event cancelled sequence",
    "EVENT_CANCELLED_STAGE_NAME": "Event Cancelled Stage Name",
    "EVENT_COMMUNICATION": "Event Communication",
    "EVENT_CONTAINS_PARTICIPANTS": "The event contains participants",
    "EVENT_CONTENT": "Event content",
    "EVENT_CREATE": "Event Create",
    "EVENT_CREATION_PROGRESS": "Event creation progress",
    "EVENT_DASHBOARD": "Event dashboard",
    "EVENT_DATES_SETTINGS": "Event dates settings",
    "EVENT_DATE_SETTINGS": "Event date settings",
    "EVENT_DETAILS": "Event details",
    "EVENT_DOCUMENTS": "Event documents",
    "EVENT_END": "Event end",
    "EVENT_END_DATE": "Event end date",
    "EVENT_FIELD": "Event field",
    "EVENT_FIELDS": "Event fields",
    "EVENT_FIELDS_CREATE": "Add event field",
    "EVENT_FIELDS_DELETE": "Delete event field",
    "EVENT_FIELDS_GLOBAL_SCOPES": "Global event fields",
    "EVENT_FIELDS_READ": "View event field",
    "EVENT_FIELDS_SPECIFIC_SCOPES": "Local event fields",
    "EVENT_FIELDS_UPDATE": "Edit event field",
    "EVENT_FILTER": "Event filter",
    "EVENT_ID": "Event ID",
    "EVENT_IMAGE": "Event image",
    "EVENT_LEVEL_EMAIL_MARKETING": "Event level - email marketing",
    "EVENT_LEVEL_FIELDS_MANAGER": "Event level - fields manager",
    "EVENT_LEVEL_PARTICIPANTS": "Event level - participants",
    "EVENT_LEVEL_ROOMS": "Event level - rooms",
    "EVENT_LEVEL_SESSIONS": "Event level - sessions",
    "EVENT_LEVEL_WEBSITE": "Event level - website",
    "EVENT_LEVEL_WORKFLOWS": "Event level - workflows",
    "EVENT_LINK": "Event link",
    "EVENT_LISTING": "Event listing",
    "EVENT_MAPPING": "Event mapping",
    "EVENT_MARKETING": "Event marketing",
    "EVENT_MODULES": "Event modules",
    "EVENT_MODULE_NAME": "Event module name",
    "EVENT_OFFLINE_DATE": "Event offline date",
    "EVENT_PAGE": "Event page",
    "EVENT_PAGE_LINK_BUTTON": "Event page link button",
    "EVENT_PARTICIPANT_CAPACITY": "Event participant capacity",
    "EVENT_PRESETS": "Event presets",
    "EVENT_PROCESSES": "Event processes",
    "EVENT_PUBLICATION_DATE": "Event publication date",
    "EVENT_PUBLICATION_DATE_ERROR": "Must be before Event Offline Date (or disabled)",
    "EVENT_READ": "Event Read",
    "EVENT_REGISTRATION_DATE": "Event registration deadline",
    "EVENT_SCOPES": "General event capabilities",
    "EVENT_SERIES": "Event series",
    "EVENT_SERIES_CALENDAR_EXPLANATION": "Add a new event to this event series by clicking anywhere on the calendar.",
    "EVENT_SETTINGS": "Event settings",
    "EVENT_START": "Event start",
    "EVENT_START_DATE": "Event start date",
    "EVENT_STATUS": "Event status",
    "EVENT_STATUS_CHANGES_TO_OFFLINE": "Event status changes to \"offline\"",
    "EVENT_STATUS_CHANGES_TO_PUBLISHED": "Event status changes to \"published\"",
    "EVENT_TEMPLATE": "Event template",
    "EVENT_TEMPLATES": "Event templates",
    "EVENT_TEMPLATE_DETAILS": "Event template details",
    "EVENT_TEXT_FIELD": "Event text field",
    "EVENT_TYPE": "Select the following \"Events to send\" type in the dropdown: checkout.session.completed",
    "EVENT_UPDATE": "Event Update",
    "EVENT_URL": "Event URL",
    "EVENT_VISIBILITY": "Event visibility",
    "EVENT_WAITING_LIST_WIDGET_DESCRIPTION": "Current status of the waiting list",
    "EVENT_WAITING_LIST_WIDGET_EXAMPLE": "Example: Total, registered, waiting list and sessions in use count",
    "EVENT_WAITING_LIST_WIDGET_TITLE": "Event waiting list",
    "EVENT_WEBSITE": "Event website",
    "EVENT_WITH_ACTIVITIES": "Event with activities",
    "EVENT_WORKFLOWS": "Event Workflows",
    "EVENT_WORKFLOW_AUTOMATIONS": "Event Workflow Automations",
    "EVENT_WORKFLOW_AUTOMATION_FIELDS": "Event workflow automation fields",
    "EVENT_ZIP_FILE": "Event Zip file",
    "EVENT__EXT2_SCOPES": "Extra event capabilities 2",
    "EVENT__EXT_SCOPES": "Extra event capabilities",
    "EVERYTHING_WILL_BE_COPIED_OVER_INTO_THE_TEMPLATE": "Everything will be copied over into the template, except for the participants",
    "EXAMPLE": "Example",
    "EXAMPLE_SCRIPT": "Example script",
    "EXECUTE_REFUND": "Execute refund",
    "EXISTS": "Exists",
    "EXIT_FULLSCREEN": "Exit Fullscreen",
    "EXPORT": "Export",
    "EXPORT_4_0": "Export 4.0 Preview",
    "EXPORT_ACTIVITIES": "Export activities",
    "EXPORT_CONTACTS": "Export contacts",
    "EXPORT_DOCUMENTS": "Export documents",
    "EXPORT_LATEST_VERSION": "Export latest version",
    "EXPORT_ORDERS": "Export orders",
    "EXPORT_PARTICIPANTS": "Export participants",
    "EXPORT_PARTICIPANTS_TO_DOCUMENT": "Export participants to document",
    "EXPORT_REPORT_WITH_VERSION": "Export report with version",
    "EXPORT_TO_DOCUMENT": "Export to document",
    "EXPORT_TYPE": "Export type",
    "EXPORT_USERS": "Export users",
    "EXPORT_WITH_VERSIONS": "Export with versions",
    "EXTERNAL": "External",
    "EXTERNAL_CONTACT_REFERENCE_IN_AZAVISTA": "External Contact Reference in Azavista",
    "EXTERNAL_CRM": "External CRM",
    "EXTERNAL_ID": "External ID",
    "EXTERNAL_IDENTITY_PROVIDER": "External identity provider",
    "EXTERNAL_MODULE": "External module",
    "EXTERNAL_SITE_LINK_BUTTON": "External site link button",
    "EXTERNAL_USER_ID": "External user ID",
    "FAILED_PAGE": "Failed page",
    "FEATURES_USED": "Features used",
    "FIELD": "Field",
    "FIELDS": "Fields",
    "FIELDS_INCLUDED_IN_BADGE_SCANNING_EXPORT": "Fields included in badge-scanning export",
    "FIELDS_LIST": "Fields list",
    "FIELDS_MANAGER": "Fields manager",
    "FIELDS_MATCH": "Map fields",
    "FIELDS_SEARCH": "Fields search",
    "FIELDS_TO_EXPORT": "Fields to export",
    "FIELDS_TO_SHOW_IN_EVENT_DESCRIPTION": "Fields to show in event description",
    "FIELDS_USED_TO_DISPLAY_EVENT": "Fields used to display event",
    "FIELDS_USED_TO_FILTER": "Fields used to filter",
    "FIELD_ATTRIBUTES": "Field attributes",
    "FIELD_CATEGORY": "Field category",
    "FIELD_CONDITION": "Field condition",
    "FIELD_IS_ALREADY_SELECTED": "Field '{{label}}' is already selected",
    "FIELD_LABEL_IN_AZAVISTA": "Field label in Azavista",
    "FIELD_MAPPINGS": "Field mappings",
    "FIELD_NAME": "Field name",
    "FIELD_RIGHTS": "Field Rights",
    "FIELD_TYPE": "Field type",
    "FIELD_TYPE_BOOLEAN": "Boolean",
    "FIELD_TYPE_CANNOT_BE_EDITED": "Field type cannot be edited",
    "FIELD_TYPE_DATE": "Date",
    "FIELD_TYPE_DATETIME": "Date time",
    "FIELD_TYPE_DESCRIPTION": "Description",
    "FIELD_TYPE_DOCUMENT": "Document",
    "FIELD_TYPE_EMAIL": "Email",
    "FIELD_TYPE_FROM_MULTI_SELECT": "From multi-select",
    "FIELD_TYPE_IMAGE": "Image",
    "FIELD_TYPE_INTEGER": "Integer",
    "FIELD_TYPE_MULTISELECT": "Multi select",
    "FIELD_TYPE_MULTI_SELECT": "Multi select",
    "FIELD_TYPE_NUMBER": "Number",
    "FIELD_TYPE_OPINION_SCALE": "Opinion scale",
    "FIELD_TYPE_PREFERENCE": "Preference",
    "FIELD_TYPE_RATING": "Rating",
    "FIELD_TYPE_REFERENCE": "Reference",
    "FIELD_TYPE_RELATION": "Relation",
    "FIELD_TYPE_SELECT": "Select",
    "FIELD_TYPE_STRING": "Text",
    "FIELD_TYPE_TEXT": "Text",
    "FIELD_TYPE_TIME": "Time",
    "FIELD_TYPE_TIMEZONE": "Timezone",
    "FIELD_TYPE_TRAVEL_DATE": "Travel date",
    "FIELD_TYPE_URL": "Url",
    "FIELD_TYPE_VIRTUAL_TEXTAREA": "Text area",
    "FIELD_VALIDATION": "Field Validation",
    "FILE": "File",
    "FILES": "Files management",
    "FILE_DOWNLOAD_DIALOG_CONTENT": "This export is composed of multiple files. Click on the one you want to download:",
    "FILE_DOWNLOAD_DIALOG_TITLE": "Ready to export",
    "FILE_SIZE": "File size",
    "FILE_SIZE_IN_BYTES": "File size (bytes)",
    "FILE_URL": "File URL",
    "FILLER_FIELD": "Filler field",
    "FILTER": "Filter",
    "FILTER_NAME": "Filter name",
    "FILTER_PARTICIPANTS": "Filter participants",
    "FINALIZATION_SEQUENCE": "Finalization sequence",
    "FINAL_FORM_IN_STAGE_TRIGGER": "Final form in stage trigger",
    "FINAL_FORM_SUBMIT_TRIGGER": "Final form submit trigger",
    "FINANCE_SCOPES": "Tickets and products capabilities",
    "FINANCIAL_CREATE": "Add tickets and products",
    "FINANCIAL_DELETE": "Delete tickets and products",
    "FINANCIAL_READ": "View tickets and products",
    "FINANCIAL_UPDATE": "Edit tickets and products",
    "FINAN_CREATE": "Tickets & Prod. Create",
    "FINAN_DELETE": "Tickets & Prod. Delete",
    "FINAN_READ": "Tickets & Prod. Read",
    "FINAN_SCOPES": "Tickets & Prod. Scopes",
    "FINAN_UPDATE": "Tickets & Prod. Update",
    "FINISH": "Finish",
    "FIRST_CREATE_REPORT_VERSION": "First create report version",
    "FIRST_NAME": "First name",
    "FIVE_IMAGE": "5 images",
    "FIXED_HEIGHT": "Fixed height",
    "FLIP_BACKSIDE_180": "Flip backside 180",
    "FLOOR": "Floor",
    "FLOOR_PLAN": "Floor plan",
    "FLOOR_PLANS": "Floor plans",
    "FLOOR_PLAN_FIELDS": "Floor plan fields",
    "FONT": "Font",
    "FONT_FORMAT": "Font format",
    "FONT_HEIGHT_DOTS": "Font height (dots)",
    "FONT_NAME": "Font name",
    "FONT_SIZE": "Font size",
    "FOOTER": "Footer",
    "FORGOT_PASSWORD": "Forgot password",
    "FORGOT_YOUR_PASSWORD": "Forgot your password?",
    "FORGOT_YOUR_PASSWORD_INSTRUCTION": "Enter your email, and we'll send you a link to reset your password",
    "FORM": "Form",
    "FORMAT_MAXIMUM": "Maximum value",
    "FORMAT_MINIMUM": "Minimum value",
    "FORMS": "Forms",
    "FORMS_TO_DISPLAY": "Forms to display",
    "FORM_BUTTON": "Form button",
    "FORM_SUBMIT": "Form Submit",
    "FOR_ALL_OTHER_SETTINGS": "For all other settings regarding each module, check out module-specific settings in the left side menu.",
    "FOR_ALL_SELECTED_ITEMS": "For all selected items:",
    "FOUR_IMAGE": "4 images",
    "FOUR_IMAGE_GALLERY": "Four image gallery",
    "FREE_IN": "Free in",
    "FREE_PARTICIPANT_SPOTS_FOR_NEW_REGISTRATIONS": "Free participant spots for new registrations",
    "FREE_SLOTS": "Free slots",
    "FRIDAY": "Friday",
    "FROM": "From",
    "FROM_EMAIL": "From email",
    "FROM_EMAIL_ADDRESS": "From email address",
    "FROM_LOCAL_TIME": "From (local time)",
    "FROM_NAME": "From name",
    "FULLSCREEN": "Fullscreen",
    "FULL_REFUND": "Full refund",
    "FULL_URL": "full URL",
    "FULL_WIDTH_AND_HEIGHT_VIDEO": "Full width and height video",
    "FULL_WIDTH_HEIGHT_IMAGE": "Full width and height image",
    "FULL_WIDTH_HEIGHT_IMAGE_WITH_BORDER": "Full width and height image with border",
    "FULL_WIDTH_IMAGE": "Full width image",
    "FULL_WIDTH_IMAGE_WITH_BORDER": "Full width image with border",
    "FULL_WIDTH_VIDEO": "Full width video",
    "FUNCTION": "Function",
    "GENERAL_DASHBOARD": "General dashboard",
    "GENERAL_EMAIL": "Email to general email field",
    "GENERAL_OVERVIEW": "General overview",
    "GENERATE_CERTIFICATE": "Generate certificate",
    "GENERATE_PREVIEW": "Generate preview",
    "GENERATE_URL": "Generate URL",
    "GENERATE_ZPL": "Generate ZPL",
    "GENERIC_ACTIVITY_SETTINGS": "Generic activity settings",
    "GENERIC_DOCUMENTS": "Generic documents",
    "GENERIC_WORKFLOWS": "Generic workflows",
    "GJS_GOOGLE_MAPS_MODAL_HINT": "Click on the settings icon for this block, on the panel on your right, in order to insert the Google Maps code.",
    "GJS_GOOGLE_MAPS_MODAL_HINT_EXTRA": "It looks like this",
    "GLOBAL": "Global",
    "GLOBAL_EVENT": "Global event",
    "GLOBAL_EVENT_EMAIL_ASSETS": "Process assets capabilities",
    "GLOBAL_EVENT_EMAIL_SCOPES": "Process email capabilities",
    "GLOBAL_FIELDS": "Global Fields",
    "GLOBAL_FIELDS_MANAGER": "Global Fields Manager",
    "GLOBAL_FOOTER": "Global footer",
    "GLOBAL_HEADER": "Global header",
    "GLOBAL_LEVEL_CRM": "Global level - CRM",
    "GLOBAL_LEVEL_EMAIL_MARKETING": "Global level - email marketing",
    "GLOBAL_LEVEL_EVENTS": "Global level - events",
    "GLOBAL_LEVEL_FIELDS_MANAGER": "Global level - fields manager",
    "GLOBAL_LEVEL_INTEGRATIONS": "Global level - integrations",
    "GLOBAL_LEVEL_PRODUCTS_AND_TICKETS": "Global level - tickets and products",
    "GLOBAL_LEVEL_REPORTING": "Global level - reporting",
    "GLOBAL_LEVEL_ROOMS_MANAGER": "Global level - rooms manager",
    "GLOBAL_LEVEL_THEMES": "Global level - themes",
    "GLOBAL_MODULES": "Global modules",
    "GLOBAL_PROCESSES": "Global processes",
    "GOOGLE_CALENDAR": "Google Calendar",
    "GOOGLE_IFRAME_CODE": "Google IFrame Code",
    "GOOGLE_MAPS": "Google maps",
    "GOOGLE_MAPS_BLOCK_TITLE": "Google maps - This is a sample preview of the google maps section",
    "GO_TO_ACTIVITY": "Go to activity",
    "GO_TO_CONTACTS_LIST": "Go to contacts list",
    "GO_TO_EVENT": "Go to event",
    "GO_TO_EVENTS_LIST": "Go to events list",
    "GO_TO_LOGIN_PAGE": "Go to Login Page",
    "GO_TO_ORGANIZATIONS_LIST": "Go to organizations list",
    "GO_TO_WORKFLOW": "Go to workflow",
    "GRAYSCALE": "Grayscale",
    "GRAYSCALE_TEXT_ABOVE": "Grayscale-text above",
    "GRAYSCALE_TEXT_BELOW": "Grayscale-text below",
    "GROUP": "Group",
    "GROUPING": "Grouping",
    "GROUP_BY": "Group by",
    "GROUP_CHAT": "Group chat",
    "GROUP_CHAT_POST": "Group chat post",
    "H1": "Heading 1",
    "HAPPENING_NOW": "Happening now",
    "HASHTAGS": "Hashtags",
    "HEADER": "Header",
    "HEADERS_AND_FOOTERS": "Headers & Footers",
    "HEADER_LIGHT": "Header light",
    "HEADER_WITH_SUBTEXT": "Header with Subtext",
    "HEARTS": "Hearts",
    "HEIGHT": "Height",
    "HIDE_AVAILABLE_PLACES_LEFT": "Hide available places left",
    "HIDE_EVENT_PRODUCTS": "Hide event products",
    "HIGH": "High",
    "HINT_MULTIPLE_OF": "E.g.: a value of 2 validates only even numbers",
    "HOMEPAGE_URL": "Homepage URL",
    "HOME_PAGE_LINK": "Home page link",
    "HOTEL_MANAGEMENT": "Hotel Management",
    "HOURS": "Hours",
    "HOW_MANY_TABS": "How many tabs",
    "HOW_SHOULD_EVENTS_REPEAT": "How should events repeat?",
    "HTML_CODE": "HTML code",
    "HTTP_STATUS": "HTTP Status",
    "HUB_EVENT_WITH_CALENDAR": "Hub with Event Calendar",
    "ICON": "Icon",
    "ID": "ID",
    "IF": "If",
    "IMAGE": "Image",
    "IMAGES_3": "3 images",
    "IMAGE_LEFT_BUTTON_V1": "Image left, button-v1",
    "IMAGE_LEFT_BUTTON_V2": "Image left, button-v2",
    "IMAGE_LEFT_TEXT_RIGHT": "Image left, text right",
    "IMAGE_LEFT_TEXT_RIGHT_WITH_BORDER": "Image left, text right, with border",
    "IMAGE_LOGO_ABOVE": "Image logo above",
    "IMAGE_LOGO_BELOW": "Image logo below",
    "IMAGE_LOGO_RIGHT": "Image left, logo right",
    "IMAGE_PLUS_TEXT": "Image + Text",
    "IMAGE_RIGHT_BUTTON_V1": "Image right, button-v1",
    "IMAGE_RIGHT_BUTTON_V2": "Image right, button-v2",
    "IMAGE_RIGHT_TEXT_BUTTON_V1": "Image right, text + button-v1",
    "IMAGE_RIGHT_TEXT_LEFT": "Image right, text left",
    "IMAGE_RIGHT_TEXT_LEFT_WITH_BORDER": "Image right, text left, with border",
    "IMAGE_RIGHT_WITH_TEXT_IMAGE_LEFT_WITH_TEXT": "Image Right with text - Image Left with text",
    "IMAGE_SAVED": "Image saved",
    "IMAGE_SECTIONS": "Image sections",
    "IMAGE_SET": "Image set",
    "IMMEDIATE": "Immediate",
    "IMPERSONATE": "Impersonate",
    "IMPLEMENTATION": "Implementation",
    "IMPORT": "Import file",
    "IMPORT_A_THEME": "Import a theme",
    "IMPORT_FROM_FILE": "Import from file",
    "IMPORT_MAP_FIELDS_HELP_MESSAGE": "Match all fields from the sheet you uploaded to the already created fields from Azavista Field Manager",
    "IMPORT_USERS": "Import users",
    "IMPORT_USERS_DESCRIPTION": "Import or add users from your organization in Azavista",
    "INACTIVE": "Inactive",
    "INBOUND": "Inbound",
    "INBOUND_WEBHOOK": "Inbound webhook",
    "INCLUDE_PARTICIPANTS_WITH_NO_ACTIVITIES": "Include participants with no activities",
    "INGENICO_FINAL_AUTHORIZATION": "Final authorization",
    "INGENICO_PRE_AUTHORIZATION": "Pre-authorization",
    "INGENICO_SALE": "Sale",
    "INGRESS": "Ingress",
    "INITIATION_SEQUENCE": "Initiation sequence",
    "INSPECT": "Inspect",
    "INSPECT_MAPPING": "Inspect mapping",
    "INTEGRATION": "Integration",
    "INTEGRATIONS": "Integrations",
    "INTEGRATIONS_CREATE": "Add integrations",
    "INTEGRATIONS_DELETE": "Delete integrations",
    "INTEGRATIONS_READ": "View integrations",
    "INTEGRATIONS_SCOPES": "Integrations Scopes",
    "INTEGRATIONS_UPDATE": "Edit integrations",
    "INTEGRATION_FIELDS": "Integration fields",
    "INTEGRATION_NAME": "Integration name",
    "INTEGRATION_SCOPES": "Integrations capabilities",
    "INTERFACE_LANGUAGE": "Interface language",
    "INTERNAL_EMAIL_NAME": "Internal email name",
    "INTERRUPT": "Interrupt",
    "INTERRUPT_WORKFLOW": "Interrupt workflow",
    "INTERRUPT_WORKFLOW_DIALOG_ARE_YOU_SURE": "Are you sure that you want to interrupt this workflow? This means that all pending messages and actions will be removed. This action cannot be undone.",
    "INVAILD_PATH_FORMAT": "Invalid path format",
    "INVALID_GA_FORMAT": "Invalid Measurement ID format",
    "INVALID_GTM_FORMAT": "Invalid Container ID format",
    "INVALID_HEX_FORMAT": "Invalid hexadecimal format",
    "INVALID_START_AND_END_DATES": "Invalid start and end dates",
    "INVALID_URL_FORMAT": "Invalid URL format",
    "INVALID_USERNAME_OR_PASSWORD": "Invаlid username or password",
    "INVITATION_EMAIL": "Invitation email",
    "INVITATION_STAGE_NAME": "Invitation Stage Name",
    "INVITATION_STATE_NAME": "Invitation Stage Name",
    "INVITATION_WORKFLOWS": "Invitation workflows",
    "INVITATION_WORKFLOW_EXPLANATION": "Invitation: invite participants to invite-only event or public-event",
    "INVITATION_WORKFLOW_NAME": "Invitation",
    "INVITED": "Invited",
    "INVITE_ONLY": "Invite only",
    "INVOICE": "Invoice",
    "INVOICE_PAYMENT_DEPENDENCY": "Invoice payment dependency",
    "IN_CRM": "In CRM",
    "IN_EVENT": "In event",
    "IN_MINUTES": "In minutes",
    "IN_PROGRESS": "In Progress",
    "IN_PROGRESS_STAGE_NAME": "In-progress stage name",
    "IN_SPREADSHEET": "In spreadsheet",
    "IN_THE_MENU": "In the menu",
    "IS_A_REFERENCE_FIELD": "Is a reference field",
    "IS_DIFFERENT_FROM": "Is different from",
    "IS_EMPTY": "Is empty",
    "IS_EQUAL_TO": "Is equal to (case sensitive)",
    "IS_EQUAL_TO_CASE_SENSITIVE": "Is equal to (case sensitive)",
    "IS_FORM": "Is form",
    "IS_GREATER_OR_EQUAL_THAN": "Is greater or equal than",
    "IS_GREATER_THAN": "Is greater than",
    "IS_IN_EXTERNAL_CRM": "Is in external CRM",
    "IS_LESS_OR_EQUAL_THAN": "Is less or equal than",
    "IS_LESS_THAN": "Is less than",
    "IS_LOCKED": "Is locked",
    "IS_LOGIN": "Is login",
    "IS_NOT_EMPTY": "Is not empty",
    "IS_NOT_IN_EXTERNAL_CRM": "Is not in external CRM",
    "IS_NOT_ONE_OF": "Is not one of",
    "IS_ONE_OF": "Is one of",
    "IS_PUBLISHED": "Is published",
    "ITEMS_SELECTED": "items selected",
    "ITEM_NOT_FOUND": "Item not found",
    "JAVASCRIPT": "Javascript",
    "JOB_ERRORS": "Job errors",
    "JOB_FAILED": "Job failed",
    "JOB_PROGRESS": "Job progress",
    "JOB_TITLE": "Job title",
    "JUMBOTRON": "Jumbotron",
    "KNOWLEDGE_BASE": "Knowledge base",
    "LABEL": "Label",
    "LABEL_HEIGHT": "Label Height",
    "LABEL_HEIGHT_MM": "Label height (mm)",
    "LABEL_WIDTH": "Label Width",
    "LABEL_WIDTH_MM": "Label width (mm)",
    "LANGUAGE": "Language",
    "LANGUAGES": "Languages",
    "LANGUAGE_DROPDOWN": "Language Dropdown",
    "LANGUAGE_SEARCH": "Language Search",
    "LARGE": "Large",
    "LAST_EDITED": "Last edited",
    "LAST_LOGIN_AT": "Last login at",
    "LAST_NAME": "Last name",
    "LAST_REGISTRATION_DATE_ERROR": "Must be before Event Publication Date and before Event Offline Date (or disabled)",
    "LAYOUT": "Layout",
    "LAYOUTS": "Layouts",
    "LAYOUT_NAME": "Layout name",
    "LEAD_SCAN": "Lead Scan",
    "LEAD_SCAN_APP_BUTTON": "Lead-Scan App Button",
    "LEAD_SCAN_SETTINGS": "Lead scan settings",
    "LEFT": "Left",
    "LEFT_AND_UP": "Left and up",
    "LEFT_MENU_DRAWER": "Left menu drawer",
    "LETS_GET_STARTED": "Let's get started with Azavista! Please complete the steps below in order for your Azavista organization to be configured.",
    "LINE_HEIGHT": "Line height",
    "LINK": "Link",
    "LINK_CLICKED": "Link clicked",
    "LINK_DETAILS": "Link details",
    "LINK_GENERATION": "Link generation",
    "LINK_THIS_VIEW_TO": "Link this view to",
    "LIST_VIEW": "List view",
    "LIVE": "Live",
    "LIVE_REGISTRATION_SESSIONS_WITH_A_RESERVED_SPOT": "Live registration sessions with a reserved spot",
    "LOADING": "Loading...",
    "LOADING_CLUSTER_ITEMS": "Loading items",
    "LOADING_PUBLISHED_CAMPAIGNS": "Loading published campaigns...",
    "LOAD_IN_IFRAME": "Load in IFrame",
    "LOCAL": "Local",
    "LOCALISATION": "Localisation",
    "LOCAL_EVENT_FIELDS_CREATE": "Add local event fields",
    "LOCAL_EVENT_FIELDS_DELETE": "Delete local event fields",
    "LOCAL_EVENT_FIELDS_UPDATE": "Edit local event fields",
    "LOCAL_VIDEO": "Local video",
    "LOCATION": "Location",
    "LOCATIONS": "Locations",
    "LOCKED": "Locked",
    "LOCK_VALUE": "Lock value",
    "LOG": "Log",
    "LOGIN": "Login",
    "LOGIN_FORM": "Login form",
    "LOGIN_LINK": "Login link",
    "LOGIN_METHODS": "Login methods",
    "LOGISTICS_AND_SUPPLIER_MANAGEMENT": "Logistics and supplier management",
    "LOGISTICS_MANAGEMENT": "Logistics Management",
    "LOG_OUT": "Log out",
    "LOW": "Low",
    "MAGNIFICATION": "Magnification",
    "MAINPARTICIPANT_ASSIGNED_REQUIRED": "Require assigning the main participant",
    "MAINPARTICIPANT_CONFIRMATION_EMAIL": "Main participant's confirmation email",
    "MAIN_EDITOR": "Main editor",
    "MAIN_PARTICIPANT": "Main participant",
    "MAIN_URL": "Main URL",
    "MANAGE_ATTRIBUTE_MAPPING": "Manage attribute mapping",
    "MANAGE_COLUMNS": "Manage columns",
    "MANAGE_CONDITIONS": "Manage conditions",
    "MANAGE_FILTER": "Manage filter",
    "MANAGE_FORMS": "Manage forms",
    "MANAGE_TABLE_COLUMNS.AVAILABLE_COLUMNS": "Available columns",
    "MANAGE_TABLE_COLUMNS.COLUMNS_TO_DISPLAY": "Columns to display",
    "MANAGE_TABLE_COLUMNS.DRAG_AND_DROP_TO_REORDER": "Drag and drop to re-order",
    "MANAGE_TABLE_COLUMNS.MANAGE_COLUMNS": "Manage columns",
    "MANUAL": "Manual",
    "MANUAL_APPROVAL": "Manual approval",
    "MARKETING": "Marketing",
    "MARKETING_URL": "Marketing URL",
    "MARKETING_URL_PATH_INPUT_HINT": "A marketing link can only contain lower characters a to z, digits 0 to 9 and \"-\". It should start with a lower letter and must contain a minimum of 4 characters.",
    "MARK_ORDER_AS_CLOSED": "Mark as Closed",
    "MATCH_ORGANIZATIONS": "Match organizations",
    "MAXIMUM": "Maximum",
    "MAXIMUM_LENGTH": "Maximum length",
    "MAXIMUM_PRODUCTS_PER_BUYER_LIMIT_REACHED": "Maximum products per buyer limit reached",
    "MAXIMUM_TIME_TO_COMPLETE_REGISTRATION_FORM": "Maximum time to complete registration form",
    "MAXIMUM_TIME_TO_START_WITH_REGISTRATION": "Maximum time to start with registration",
    "MAXIMUM_VALUE": "Maximum value",
    "MAX_CAPACITY_OF_PARTICIPANTS": "Max event capacity in participants",
    "MAX_HEIGHT": "Max height",
    "MAX_PER_BUYER": "Max per buyer",
    "MAX_UNITS": "Max unit(s)",
    "MAX_WIDTH": "Max width",
    "MEDIA_URL": "Media URL",
    "MEDIUM": "Medium",
    "MEDIUMS": "Mediums",
    "MEETINGROOMS": "Meeting rooms",
    "MEETINGS_AND_ROOMS": "Meetings & rooms",
    "MEETINGS_AND_ROOMS_CALENDAR": "Meetings & Rooms calendar",
    "MEETINGS_AND_ROOMS_OVERVIEW": "Meetings & Rooms overview",
    "MEETINGS_CALENDAR": "Meetings calendar",
    "MEETINGS_OVERVIEW": "Meetings overview",
    "MEETING_ROOM": "Meeting room",
    "MEETING_ROOMS": "Meeting rooms",
    "MEETING_ROOMS_MANAGEMENT": "Meeting Rooms Management",
    "MEETING_ROOMS_OVERVIEW": "Meeting rooms overview",
    "MEMBER_FIELDS": "Member fields",
    "MEMBER_MAPPING": "Member mapping",
    "MEMBER_MODULE_NAME": "Member module name",
    "MENU_EDITOR": "Menu editor",
    "MERCHANT_REFERENCE_NUMBER": "Merchant Reference Number",
    "MERGE_FIELD": "Merge field",
    "MERGE_INTO_ONE_DOCUMENT": "Merge into one document",
    "MERGE_LABELS": "Merge labels",
    "MERGE_TEXT": "Merge Text",
    "MERGE_TEXT_FIELD_VALUE": "Merge Text field value",
    "MESSAGE": "Message",
    "MESSAGES": "Messages",
    "MESSAGE_ID": "Message ID",
    "MESSAGE_TO_CONTACT": "Message to contact",
    "MESSAGE_TO_PARTICIPANT": "Message to participant",
    "MESSAGING": "Messaging",
    "MINIMUM": "Minimum",
    "MINIMUM_LENGTH": "Minimum length",
    "MINIMUM_SLOT_DURATION": "Minimum slot duration",
    "MINIMUM_VALUE": "Minimum value",
    "MINUS": "Minus",
    "MINUTES": "Minutes",
    "MIN_PER_BUYER": "Min per buyer",
    "MIRROR_BOTH_SIDES": "Mirror both sides",
    "MODERATE": "Moderate",
    "MODERATION": "Moderation",
    "MODERATION_SETTINGS": "Moderation settings",
    "MODERATORS": "Moderators",
    "MODULE": "Module",
    "MODULES": "Modules",
    "MODULE_ACTIVITY": "Activities",
    "MODULE_AZAVISTA2": "Azavista 2.0",
    "MODULE_CONTENT": "Content",
    "MODULE_CRM": "CRM",
    "MODULE_DOCUMENT": "Documents",
    "MODULE_DOCUMENT_LOCAL": "Documents",
    "MODULE_EMAIL_CAMPAIGN": "Email marketing",
    "MODULE_EVENT": "Events",
    "MODULE_EVENT_APP": "Event app",
    "MODULE_EVENT_APP_LOCAL": "Event app",
    "MODULE_EVENT_WORKFLOW": "Event workflow",
    "MODULE_FIELD_MANAGER": "Field manager",
    "MODULE_FIELD_MANAGER_LOCAL": "Field manager",
    "MODULE_FINANCIAL": "Tickets and products",
    "MODULE_GENERIC_TEAM": "Generic teams",
    "MODULE_GLOBAL": "Global",
    "MODULE_INTEGRATION": "Integrations",
    "MODULE_NAME": "Module name",
    "MODULE_PARTICIPANT": "Participants",
    "MODULE_PROJECT": "Project management",
    "MODULE_REPORT": "Reports",
    "MODULE_REPORT_LOCAL": "Reports",
    "MODULE_ROOM_MANAGEMENT": "Meeting room management",
    "MODULE_ROOM_MANAGEMENT_LOCAL": "Meeting room management",
    "MODULE_SETTINGS": "Module settings",
    "MODULE_THEME": "Themes",
    "MODULE_USER_MANAGEMENT": "User Management",
    "MODULE_WORKFLOW_LOCAL": "Workflows",
    "MONDAY": "Monday",
    "MONTH": "Month",
    "MONTHLY": "Monthly",
    "MOVE_PARTICIPANT": "Move participant",
    "MULTIPLE_OF": "Multiple of",
    "MULTIREGISTRATION_COMPLETED_STAGE": "Multi-registration completed stage name",
    "MULTIREGISTRATION_FORM": "Multi registration form",
    "MULTIREGISTRATION_PENDING_STAGE": "Multi-registration pending stage name",
    "MULTIREGISTRATION_REGISTRATION_COMPLETED_STAGE": "Multi-registration's registration completed stage name",
    "MULTIREGISTRATION_REGISTRATION_PENDING_STAGE": "Multi-registration's registration pending stage name",
    "MULTI_REGISTRATION_CONFIRMATION_STAGE_NAME": "Multi registration confirmation stage name",
    "MULTI_REGISTRATION_INVITATION_STAGE_NAME": "Multi registration invitation stage name",
    "MULTI_REGISTRATION_LIMIT": "Multi registration limit",
    "MULTI_REGISTRATION_LIMIT_FIELD": "Multi registration limit field",
    "MULTI_REGISTRATION_TYPE": "Multi registration type",
    "MULTI_REGISTRATION_WORKFLOW_EXPLANATION": "Multi registration: Workflow to manage multi registrations - where one person is able to manage several registrations",
    "MULTI_REGISTRATION_WORKFLOW_NAME": "Multi registration",
    "MUST_BE_AFTER_EVENT_PUBLICATION_DATE": "Must be after Event Publication Date",
    "MUST_BE_AFTER_EVENT_PUBLICATION_DATE_AND_LAST_REGISTRATION": "Must be after Event Publication Date and after Last Registration Date",
    "MUST_BE_ZERO_OR_HIGHER": "Must be 0 or higher",
    "MUST_NOT_CONTAIN_SPACES": "Must not contain spaces",
    "MUST_START_WITH_HTTPS": "Must start with http:// or https://",
    "MY_ACCOUNT": "My account",
    "MY_AGENDA": "My agenda",
    "MY_EVENTS": "My events",
    "MY_JOBS": "My jobs",
    "MY_JOBS_LIST": "My jobs list",
    "MY_ORDERS": "My orders",
    "MY_ORGANIZATION": "My organization",
    "MY_PROFILE": "My profile",
    "NAME": "Name",
    "NAME_ALREADY_EXISTS": " Name already exists",
    "NAME_CARD": "Name card",
    "NAME_MUST_CONTAIN_A_VALUE": "Name must contain a value",
    "NAME_OF_SEQUENCE": "Name of sequence",
    "NEVER": "Never",
    "NEW": "New",
    "NEWSFEED": "Newsfeed",
    "NEWSFEED_SETTINGS": "Newsfeed settings",
    "NEW_CONTACT": "New contact",
    "NEW_PASSWORD": "New password",
    "NEW_SECTION": "New section",
    "NEW_WINDOW": "New window",
    "NEXT_STAGE": "Next stage",
    "NEXT_WORKFLOW": "Next workflow",
    "NONE": "None",
    "NON_DUPLICATES": "Non-duplicates",
    "NON_EMPTY_FIELDS": "None of these fields can be empty",
    "NORMAL": "Normal",
    "NOTE": "note",
    "NOTE_TAKING": "Note Taking",
    "NOTE_TAKING_SETTINGS": "Note Taking Settings",
    "NOTIFICATIONS": "Notifications",
    "NOTIFICATIONS_SETTINGS": "Notifications settings",
    "NOT_ALLOWED_TO_CANCEL_EVENT": "You are not allowed to cancel events",
    "NOT_ALLOWED_TO_PERFORM_ACTION": "You are not allowed to perform this action",
    "NOT_EARLIER_THAN": "Not earlier than",
    "NOT_EDITABLE_FIELDS": "Not editable fields",
    "NOT_LATER_THAN": "Not later than",
    "NOT_STARTED": "Not Started",
    "NOW": "Now",
    "NO_AMENITIES_IN_ROOM": "No amenities have been assigned to this room",
    "NO_AVAILABLE_ITEMS_FOR_THIS_CLUSTER": "There are no available items in this cluster. Please, choose another cluster.",
    "NO_DASHBOARDS_WARNING": "No dashboards to display. Please, create one by clicking on the button above.",
    "NO_DUPLICATES_FOUND": "There are no duplicates found. Please proceed.",
    "NO_DUPLICATE_EMAILS_ALLOWED": "No duplicate emails allowed",
    "NO_FORM_INTERRACTION_FOR_CANCELLATION": "No form interaction required for this cancellation stage",
    "NO_FORM_INTERRACTION_FOR_DECLINE": "No form interaction required for this decline stage",
    "NO_IMPORT_ERRORS": "There are no import errors",
    "NO_ITEMS_TO_PROCESS": "No items to process",
    "NO_MARKETING_URL_PATH": "None - Please, define a path first",
    "NO_OF_LINES": "Number of line(s)",
    "NO_PROCESS_SELECTED": "No process has been selected for this stage",
    "NO_REGISTRATION": "No registration",
    "NO_SHOW": "No show",
    "NO_UNIQUE_EMAIL_VALIDATION": "No validation on unique email addresses",
    "NO_WAITING_LIST": "No waiting list",
    "NUMBER": "Number",
    "NUMBERS_IN_CIRCLES": "Numbers in circles",
    "NUMBERS_ONLY": "Numbers only",
    "NUMBER_OF_PARTICIPANTS": "Number of participants",
    "NUMBER_OF_STREAMS": "Number of streams",
    "OBJECT": "Object",
    "OBJECT_COUNT_WIDGET_DESCRIPTION": "Count total number of objects: events, CRM organizations, CRM contacts",
    "OBJECT_COUNT_WIDGET_EXAMPLE": "Total number of events",
    "OBJECT_COUNT_WIDGET_TITLE": "Object count",
    "OBJECT_MAPPING": "Object mapping",
    "OFFLINE_DATE": "Offline date",
    "OFFSET": "Offset",
    "OFF_LINE": "Off-line",
    "OK": "OK",
    "ON": "On",
    "ONE_COLUMN_TEXT": "One column text",
    "ONE_IMAGE_GALLERY": "One image gallery",
    "ONLINE": "Online",
    "ONLINE_PAYMENT_DEPENDENCY": "Online payment dependency",
    "ONLY_ASSIGN_TASKS_FROM_SAME_PROJECT": "Please choose tasks that are belong to a same project to assign users/teams",
    "ONLY_CONTACTS_WHO_ARE_NOT_IN_AN_EVENT_WILL_BE_DELETED": "Only contacts who are not in an event will be deleted",
    "ONLY_FLOW_NAME": "Only Flow name",
    "ONLY_LETTERS_DIGITS_AND_UNDERSCORES_ARE_ALLOWED": "Only letters, digits and underscores are allowed",
    "ONLY_THOSE_WHO_GET_INVITATIONS": "Only those who get invitations",
    "ONLY_THOSE_WITH_A_LOGIN": "Only those with a login",
    "ONSITE_CHECK_IN": "Onsite Check-In",
    "ONSITE_CONFERENCE": "Onsite conference",
    "ON_WAITING_LIST": "On waiting list",
    "OPEN": "Open",
    "OPENED": "Opened",
    "OPEN_EVENT": "open event",
    "OPEN_IN_NEW_TAB": "Open in new tab",
    "OPEN_LEAD_SCAN_APP": "Open LeadScan App",
    "OPEN_ON_OTHER_DEVICE": "Open on another device",
    "OPEN_REPORT": "Open report",
    "OPEN_ROOM_BY_MODERATOR": "Open room by moderator",
    "OPEN_TO_THE_PUBLIC": "Open to the public",
    "OPEN_TO_THOSE_IN_THE_CRM": "Only to those in the CRM",
    "OPERATOR": "Operator",
    "OR": "Or",
    "ORDER": "Order",
    "ORDERED_BY": "Ordered by",
    "ORDERS": "Orders",
    "ORDER_CHANGED": "Order changed",
    "ORDER_CHANGED_TRIGGER": "Order changed trigger",
    "ORDER_COMPLETED": "Order completed",
    "ORDER_COMPLETED_STAGE_NAME": "Order completed stage name",
    "ORDER_CREATION": "Order creation",
    "ORDER_DATE": "Order date",
    "ORDER_HAS_BEEN_RESENT": "Order has been resent",
    "ORDER_ID": "Order ID",
    "ORDER_IN_PROGRESS_STAGE_NAME": "Order in progress stage name",
    "ORDER_ITEM": "Order item",
    "ORDER_ITEMS": "Order items",
    "ORDER_NUMBER": "Order Number",
    "ORDER_PAYMENT_STATUS_CANCELLED_NO_REFUND": "Cancelled - No Refund",
    "ORDER_PAYMENT_STATUS_ERROR": "Error",
    "ORDER_PAYMENT_STATUS_FULL_REFUND": "Cancelled - Refund",
    "ORDER_PAYMENT_STATUS_INVOICE": "Invoice",
    "ORDER_PAYMENT_STATUS_PAID": "Paid",
    "ORDER_PAYMENT_STATUS_PARTIAL_REFUND": "Cancelled - Partial Refund",
    "ORDER_PAYMENT_STATUS_PENDING": "Pending",
    "ORDER_PAYMENT_STATUS_PENDING_FULL_REFUND": "Cancelled - Refund",
    "ORDER_PAYMENT_STATUS_PENDING_PARTIAL_REFUND": "Cancelled - Partial Refund",
    "ORDER_PENDING_STAGE_NAME": "Order pending stage name",
    "ORDER_STATUS_CHANGED": "Order status changes",
    "ORDER_SUMMARY": "Order summary",
    "ORGANIZATION": "Organization",
    "ORGANIZATIONS": "Organizations",
    "ORGANIZATION_DETAILS": "Organization details",
    "ORGANIZATION_FIELD": "Organization field",
    "ORGANIZATION_FIELDS": "Organization fields",
    "ORGANIZATION_FIELDS_CREATE": "Add organization field",
    "ORGANIZATION_FIELDS_DELETE": "Delete organization field",
    "ORGANIZATION_FIELDS_READ": "View organization field",
    "ORGANIZATION_FIELDS_SCOPES": "Organization fields",
    "ORGANIZATION_FIELDS_UPDATE": "Edit organization field",
    "ORGANIZATION_FIELDS_VIEW": "View organization field",
    "ORGANIZATION_ID": "Organization ID",
    "ORGANIZATION_MAPPING": "Organization mapping",
    "ORGANIZATION_MODULE_NAME": "Organization module name",
    "ORGANIZATION_PROCESSES": "Organization processes",
    "ORGANIZATION_URL": "Organization Url",
    "ORIGINAL_FIELD_NAME": "Original field name",
    "ORIGINAL_SIZE_IMAGE": "Original size image",
    "ORIGINATOR": "Originator",
    "OR_SELECT_FROM_STORAGE": "or select from storage",
    "OTHER": "Other",
    "OTHER_CLIENT_HAS_CHANGED_WORKFLOW_DRAFT": "The workflow draft has been modified. Your unsaved changes will be replaced with the latest modification",
    "OTHER_MODULES": "Other modules",
    "OTHER_WORKFLOWS": "Other workflows",
    "OUTBOUND": "Outbound",
    "OUTLOOK": "Outlook",
    "OVERLAP_REGISTRATION_LABEL": "Allow registration with overlapping activities",
    "OVERRIDE_EVENT_SETTINGS": "Override event settings",
    "OVERRIDE_GLOBAL_SETTINGS": "Override global settings",
    "OVERRIDE_SETTINGS": "Override settings",
    "PAGE": "Page",
    "PAGES": "Pages",
    "PAGES_CREATE": "Add website page",
    "PAGES_DELETE": "Delete website page",
    "PAGES_PUBLISH": "Publish website page",
    "PAGES_READ": "View website page",
    "PAGES_UPDATE": "Edit website page",
    "PAGE_NOT_PUBLISHED": "This webpage has not been published yet",
    "PAGE_SUBTYPE_COMPANY": "Organization Details",
    "PAGE_SUBTYPE_EMAILRESET": "Email reset",
    "PAGE_SUBTYPE_EVENTLISTING": "Event listing",
    "PAGE_SUBTYPE_LOGIN": "Log in",
    "PAGE_SUBTYPE_ORDERLISTING": "Order listing",
    "PAGE_SUBTYPE_PASSWORDRESET": "Password reset",
    "PAGE_SUBTYPE_REQUESTLISTING": "Request listing",
    "PAGE_SUBTYPE_SUBSCRIPTION": "Subscription",
    "PAGINATOR.FIRST_PAGE": "First page",
    "PAGINATOR.ITEMS_PER_PAGE": "Items per page",
    "PAGINATOR.LAST_PAGE": "Last page",
    "PAGINATOR.NEXT_PAGE": "Next page",
    "PAGINATOR.PREVIOUS_PAGE": "Previous page",
    "PAID_ENTRANCE": "Paid entrance",
    "PANEL": "Panel",
    "PAPER_TYPE": "Paper Type",
    "PARTICIPANT": "Participant",
    "PARTICIPANTS": "Participants",
    "PARTICIPANTS_BY_EVENT_TYPE_WIDGET_DESCRIPTION": "Participants from a particular event grouped by any participant fields",
    "PARTICIPANTS_BY_EVENT_TYPE_WIDGET_EXAMPLE": "Annual Conference 2021 participants by category",
    "PARTICIPANTS_BY_EVENT_TYPE_WIDGET_TITLE": "Participants grouped by specific field",
    "PARTICIPANTS_BY_STAGE_WIDGET_DESCRIPTION": "Participants of a specific event grouped per stage they are in",
    "PARTICIPANTS_BY_STAGE_WIDGET_TITLE": "Participants by stage",
    "PARTICIPANTS_COUNT": "Participants count",
    "PARTICIPANTS_CREATE": "Add participants",
    "PARTICIPANTS_CROSS_EVENTS_REPORT_EVENT_TYPE": "Event type",
    "PARTICIPANTS_DELETE": "Delete participants",
    "PARTICIPANTS_EXPORT": "Export participants",
    "PARTICIPANTS_IMPERSONATE": "Impersonate participant",
    "PARTICIPANTS_IN_THE_WAITINGLIST": "Participants in the waiting list",
    "PARTICIPANTS_LIST": "Participants list",
    "PARTICIPANTS_MANAGEMENT": "Participants management",
    "PARTICIPANTS_READ": "View participants",
    "PARTICIPANTS_SETTINGS": "Participants settings",
    "PARTICIPANTS_UPDATE": "Edit participants",
    "PARTICIPANTS_WILL_ALSO_BE_COPIED": "Participants will also be copied over into the new duplicated event",
    "PARTICIPANT_ACCOUNT_CREATION": "Participant account creation",
    "PARTICIPANT_ACTIVITY_STATUS": "Participant activity status",
    "PARTICIPANT_ACTIVITY_STATUS_APPROVAL-PENDING": "Approval pending",
    "PARTICIPANT_ACTIVITY_STATUS_ARRIVED": "Arrived",
    "PARTICIPANT_ACTIVITY_STATUS_NEW": "New",
    "PARTICIPANT_ACTIVITY_STATUS_NO-SHOW": "No show",
    "PARTICIPANT_ACTIVITY_STATUS_PAYMENT-IN-PROGRESS": "Payment in progress",
    "PARTICIPANT_ACTIVITY_STATUS_REGISTERED": "Registered",
    "PARTICIPANT_ACTIVITY_STATUS_REGISTRATION-IN-PROGRESS": "Registration in progress",
    "PARTICIPANT_ACTIVITY_STATUS_WAITING-LIST": "Waiting list",
    "PARTICIPANT_ADDITIONAL_SCOPES": "Participants extra capabilities",
    "PARTICIPANT_APP_PREVIEW": "Preview participant Event App",
    "PARTICIPANT_CONFIRMATION_CODE": "Participant confirmation code",
    "PARTICIPANT_CREATOR": "Participant creator",
    "PARTICIPANT_DATE_FIELD": "Participant date field",
    "PARTICIPANT_DETAILS": "Participant details",
    "PARTICIPANT_DOCUMENTS": "Participant documents",
    "PARTICIPANT_DOES_NOT_EXIST_ANYMORE": "Participant does not exist anymore",
    "PARTICIPANT_EMAIL": "Participant email",
    "PARTICIPANT_ENTERS_STAGE": "Participant enters stage",
    "PARTICIPANT_FIELD": "Participant field",
    "PARTICIPANT_FIELDS": "Participant fields",
    "PARTICIPANT_FIELDS_CREATE": "Add participant fields",
    "PARTICIPANT_FIELDS_DELETE": "Delete participant fields",
    "PARTICIPANT_FIELDS_READ": "View participant fields",
    "PARTICIPANT_FIELDS_SCOPES": "Participant fields",
    "PARTICIPANT_FIELDS_UPDATE": "Edit participant fields",
    "PARTICIPANT_FIELD_VALUE": "Participant field value",
    "PARTICIPANT_FILTER": "Participant filter",
    "PARTICIPANT_ID": "Participant ID",
    "PARTICIPANT_INFORMATION": "Participant Information",
    "PARTICIPANT_IS_CREATED": "Participant is created",
    "PARTICIPANT_IS_CREATED_OR_CONTACT_IS_UPDATED": "Participant is created or contact is updated",
    "PARTICIPANT_LIST": "Participant list",
    "PARTICIPANT_LOGIN_LINK": "Participant login link",
    "PARTICIPANT_ORDER": "Participants order",
    "PARTICIPANT_PASSWORD_RESET": "Participant password reset",
    "PARTICIPANT_PROCESSES": "Participant processes",
    "PARTICIPANT_SCOPES": "Participants capabilities",
    "PARTICIPANT_SETTINGS": "Participant settings",
    "PARTICIPANT_SUBMITS_STAGE": "Participant submits stage",
    "PARTICIPANT_TEAMS": "Participant teams",
    "PASSWORD": "Password",
    "PASSWORDS": "Passwords",
    "PASSWORDS_DO_NOT_MATCH": "Passwords do not match",
    "PASSWORD_NOT_COMPLEX_ENOUGH": "Password is not complex enough. Must be at least 8 characters with at least 1 lowercase and 1 uppercase letters",
    "PASSWORD_SUCCESSFULLY_UPDATED": "Password successfully updated",
    "PASTE_THE_CODE_HERE": "Paste the code here",
    "PATH": "Path",
    "PATH_IN_USE": "Path in use",
    "PATH_IN_USE_BY": "Path in use by",
    "PAUSE": "Pause",
    "PAYMENT": "Payment",
    "PAYMENT_FAILED_PAGE": "Payment failed page",
    "PAYMENT_METHOD": "Payment method",
    "PAYMENT_PROVIDER": "Payment provider",
    "PAYMENT_SETTINGS": "Payment Settings",
    "PAYMENT_TYPE": "Payment type",
    "PAYMENT_WAITINGLIST_WORKFLOW_NAME": "Payment waiting list",
    "PAYMENT_WAITING_LIST_ENGAGEMENT_SEQUENCE": "Payment engagement sequence",
    "PAYMENT_WAITING_LIST_WORKFLOW_EXPLANATION": "Payment waiting list: Paid Registrations with max capacity and waiting list option",
    "PAYMENT_WORKFLOWS": "Payment workflows",
    "PAYMENT_WORKFLOW_EXPLANATION": "Payment: manage registration to paid event",
    "PAYMENT_WORKFLOW_NAME": "Payment",
    "PAYONE_FINAL_AUTHORIZATION": "Final authorization",
    "PAYONE_PRE_AUTHORIZATION": "Pre-authorization",
    "PAYONE_SALE": "Sale",
    "PAY_BY_INVOICE": "Pay by invoice",
    "PENDING": "Pending",
    "PENDING_APPROVAL": "Pending Approval",
    "PERCENTAGE": "Percentage",
    "PERCENTAGE_OF_CANCELLATION_COST": "Percentage of cancellation cost for participant",
    "PERIOD": "Period",
    "PERMISSION_ACTIVITY": "Activity",
    "PERMISSION_CONTACT_ASSET": "Contact asset",
    "PERMISSION_CONTACT_CAMPAIGN": "Contact campaign",
    "PERMISSION_CONTACT_CAMPAIGN_TYPE": "Contact campaign type",
    "PERMISSION_CONTACT_FIELD": "Contact field",
    "PERMISSION_CONTACT_TEMPLATE": "Contact template",
    "PERMISSION_CRM": "CRM",
    "PERMISSION_CRM_EMAIL_PUBLISH_TEMPLATE": "CRM email publish template",
    "PERMISSION_CRM_EMAIL_SEND": "CRM send email",
    "PERMISSION_CRM_EXPORT": "CRM export",
    "PERMISSION_CRM_PROCESS": "CRM process",
    "PERMISSION_CRM_PROCESS_INTERRUPT": "CRM process interrupt",
    "PERMISSION_CRM_PROCESS_PAUSE": "CRM process pause",
    "PERMISSION_CRM_PROCESS_UPDATE_AND_CONTROL": "CRM process update and control",
    "PERMISSION_CRM_VIEW": "CRM view",
    "PERMISSION_EMAIL_ASSET": "Email asset",
    "PERMISSION_EMAIL_TEMPLATE": "Email template",
    "PERMISSION_EMAIL_TEMPLATE_PUBLISH": "Email template publish",
    "PERMISSION_ENGAGEMENT_APP_READ_SETTINGS": "Engagement app read settings",
    "PERMISSION_ENGAGEMENT_APP_UPDATE_SETTINGS": "Engagement app update settings",
    "PERMISSION_EVENT": "Event",
    "PERMISSION_EVENT_ADMIN": "Event admin",
    "PERMISSION_EVENT_APP": "Event app",
    "PERMISSION_EVENT_ASSET": "Event asset",
    "PERMISSION_EVENT_CANCEL": "Event cancel",
    "PERMISSION_EVENT_COPY": "Event copy",
    "PERMISSION_EVENT_EMAIL_ASSET": "Event email asset",
    "PERMISSION_EVENT_EMAIL_CAMPAIGN": "Event email campaign",
    "PERMISSION_EVENT_EMAIL_SEND": "Event email send",
    "PERMISSION_EVENT_EMAIL_TEMPLATE": "Event email template",
    "PERMISSION_EVENT_EMAIL_TEMPLATE_PUBLISH": "Event email template publish",
    "PERMISSION_EVENT_EVENT_APP": "Event app",
    "PERMISSION_EVENT_FIELD": "Event field",
    "PERMISSION_EVENT_FIELD_LOCAL": "Event field local",
    "PERMISSION_EVENT_LIST": "Event list",
    "PERMISSION_EVENT_PAGE": "Event page",
    "PERMISSION_EVENT_PAGE_PUBLISH": "Event page publish",
    "PERMISSION_EVENT_PROCESS": "Event process",
    "PERMISSION_EVENT_PROCESS_INTERRUPT": "Event process interrupt",
    "PERMISSION_EVENT_PROCESS_PAUSE": "Event process pause",
    "PERMISSION_EVENT_PROCESS_UPDATE_AND_CONTROL": "Event process update and control",
    "PERMISSION_EVENT_SERIES": "Event series",
    "PERMISSION_EVENT_SERIES_PUBLISH": "Event series publish",
    "PERMISSION_EVENT_UPDATE_SETTINGS": "Event update settings",
    "PERMISSION_EVENT_VIEW": "Event view",
    "PERMISSION_EVENT_WORKFLOW": "Event workflow",
    "PERMISSION_FINANCIAL": "Financial",
    "PERMISSION_GENERIC_TEAM": "Generic team",
    "PERMISSION_GLOBAL_ADMIN": "Global admin",
    "PERMISSION_INTEGRATION": "Integration",
    "PERMISSION_INVITE_GENERIC_TEAM": "Invite generic team",
    "PERMISSION_NAME": "Permission name",
    "PERMISSION_ORGANIZATION_FIELD": "Organization field",
    "PERMISSION_PARTICIPANT": "Participant",
    "PERMISSION_PARTICIPANT_EXPORT": "Participant export",
    "PERMISSION_PARTICIPANT_FIELD": "Participant field",
    "PERMISSION_PARTICIPANT_IMPERSONATE": "Participant impersonate",
    "PERMISSION_PARTICIPANT_MANAGE_TEAM": "Participant manage team",
    "PERMISSION_PARTICIPANT_PROCESS": "Participant process",
    "PERMISSION_PARTICIPANT_PROCESS_INTERRUPT": "Participant process interrupt",
    "PERMISSION_PARTICIPANT_PROCESS_PAUSE": "Participant process pause",
    "PERMISSION_PARTICIPANT_PROCESS_UPDATE_AND_CONTROL": "Participant process update and control",
    "PERMISSION_PROFILE_PAGE": "Profile page",
    "PERMISSION_PROJECT": "Project",
    "PERMISSION_REPORT": "Report",
    "PERMISSION_REPORT_LOCAL": "Report local",
    "PERMISSION_ROOM_MANAGEMENT": "Room management",
    "PERMISSION_ROOM_MANAGEMENT_APPROVE": "Room management approve",
    "PERMISSION_ROOM_MANAGEMENT_APPROVE_LOCAL": "Room management approve local",
    "PERMISSION_ROOM_MANAGEMENT_LOCAL": "Room management local",
    "PERMISSION_STAGE": "Stage",
    "PERMISSION_TASK": "Task",
    "PERMISSION_THEME": "Theme",
    "PERMISSION_THEME_ASSET": "Theme asset",
    "PERMISSION_USER_MANAGEMENT_APICLIENT": "Api Client",
    "PERMISSION_USER_MANAGEMENT_APICLIENT_ASSIGN": "Assign Api Client",
    "PERMISSION_USER_MANAGEMENT_ROLE": "Role",
    "PERMISSION_USER_MANAGEMENT_ROLE_ASSIGN": "Assign Role",
    "PERMISSION_USER_MANAGEMENT_TEAM": "Team",
    "PERMISSION_USER_MANAGEMENT_TEAM_ASSIGN": "Assign Team",
    "PERMISSION_USER_MANAGEMENT_USER": "User",
    "PERMISSION_USER_MANAGEMENT_USER_ASSIGN": "Assign User",
    "PERMISSION_USE_API": "Use API",
    "PERMISSION_USE_WEBAPP": "Use web app",
    "PERSONAS": "Personas",
    "PHONE": "Phone",
    "PHONE_NUMBER_FIELD": "Phone number field",
    "PHOTO_GALLERY": "Photo Gallery",
    "PHOTO_GALLERY_SETTINGS": "Photo Gallery Settings",
    "PIXELS": "Pixels",
    "PLACEHOLDER_TEXT": "Placeholder text",
    "PLACEMENT": "Placement",
    "PLATFORMS": "Platforms",
    "PLEASE_CREATE_FILTER": "Please, create a filter",
    "PLEASE_FINISH_CREATING_THE_NEW_PRODUCT": "Please, finish creating the new product.",
    "PLEASE_PUBLISH_EMAIL_TEMPLATE": "Please, publish the email template in order to preview it",
    "PLEASE_PUBLISH_PAGE": "Please, publish this webpage in order to preview it",
    "PLEASE_RESAVE_THE_FOLLOWING_CONTACT_FIELDS": "Please resave the following contact fields: {{fields}}",
    "PLEASE_RESAVE_THE_FOLLOWING_FIELDS": "Please resave the following fields: {{fields}}",
    "PLEASE_SELECT_EVENT": "Please select an event.",
    "PLEASE_SELECT_LOCATION_FIRST": "Please, select a location before searching for the rooms",
    "PLUS": "Plus",
    "POLL": "Poll",
    "POLLS": "Polls",
    "POLLS_SETTINGS": "Polls settings",
    "PORTAL_HEADER": "Portal header",
    "POSTAL_CODE": "Postal code",
    "PRESENTATION": "Presentation",
    "PREVIEW": "Preview",
    "PREVIEW_AND_FINISH": "Preview and Finish",
    "PREVIEW_EVENT_APP_REQUIRE_ENABLE_STANDALONE_APP": "Preview requires the Standalone-app to be enabled",
    "PREVIEW_FLOOR_PLAN": "Preview floor plan",
    "PREVIEW_NOT_AVAILABLE": "Preview not available",
    "PREVIEW_PARTICIPANT_ENGAGEMENT_APP": "Preview participant in Engagement App",
    "PREVIEW_WEBSITE": "Preview website",
    "PREVIEW_WITH_PARTICIPANT_DATA": "Preview with participant data",
    "PRE_ARRIVAL_ENGAGEMENT_SEQUENCE": "Pre-arrival engagement sequence",
    "PRE_ARRIVAL_WORKFLOW_EXPLANATION": "Pre arrival: manage registered participants",
    "PRE_ARRIVAL_WORKFLOW_NAME": "Pre-arrival",
    "PRICE": "Price",
    "PRIORITY": "Priority",
    "PRIVATE_TOKEN": "Private token",
    "PROCEED": "Proceed",
    "PROCESS": "Process",
    "PROCESSES": "Processes",
    "PROCESSES_CONTROL_SCOPES": "Processes control",
    "PROCESSES_EXT_SCOPES": "Processes extra",
    "PROCESSES_SCOPES": "Processes",
    "PROCESS_CREATE": "Add processes",
    "PROCESS_DELETE": "Delete processes",
    "PROCESS_FIELDS": "Process fields",
    "PROCESS_INTERRUPT": "Interrupt processes",
    "PROCESS_PAUSE": "Pause processes",
    "PROCESS_READ": "View processes",
    "PROCESS_STEPS_NOT_CONFIGURED": "Not all steps are configured. In order to save progress, please configure all grey steps",
    "PROCESS_UPDATE": "Edit processes",
    "PROCESS_UPDATELIGHT": "Edit processes - light",
    "PRODUCT": "Product",
    "PRODUCTS": "Products",
    "PRODUCTS_GENERIC": "Products (generic)",
    "PRODUCT_FIELDS": "Product fields",
    "PRODUCT_GROUP": "Product group",
    "PRODUCT_GROUPS": "Product groups",
    "PRODUCT_GROUPS_GENERIC": "Product groups (generic)",
    "PRODUCT_GROUP_FIELDS": "Product group fields",
    "PRODUCT_LIMIT_REACHED": "Product limit reached",
    "PRODUCT_NAME": "Product name",
    "PRODUCT_TICKET_COUNT": "Product ticket count",
    "PRODUCT_TOTAL_PRICE": "Product total price",
    "PRODUCT_TYPE_CUSTOM": "Custom",
    "PRODUCT_TYPE_DONATION": "Donation",
    "PRODUCT_TYPE_SESSION": "Session",
    "PRODUCT_TYPE_TICKET": "Ticket",
    "PROFILE": "Profile",
    "PROFILES": "Profiles",
    "PROFILES_3": "3 profiles",
    "PROFILES_LIST": "Profiles list",
    "PROFILE_IMAGE": "Profile image",
    "PROFILE_IMAGE_ID": "Profile image ID",
    "PROFILE_PAGE": "Profile page",
    "PROFILE_PAGES": "Profile pages",
    "PROFILE_SETTINGS": "Profile settings",
    "PROFILE_WORKFLOW_EXPLANATION": "Profile: manage the profile of participants to the event",
    "PROFILE_WORKFLOW_NAME": "Profile",
    "PROGRAM": "Program",
    "PROGRAMS": "Programs",
    "PROJECT": "Project",
    "PROJECTS": "Projects",
    "PROJECTS_LIST": "Projects list",
    "PROJECT_FIELD": "Project fields",
    "PROJECT_FIELDS": "Project fields",
    "PROJECT_MANAGEMENT": "Project Management",
    "PROJECT_PRESET": "Project preset",
    "PROJECT_TEMPLATE": "Project template",
    "PROJECT_TEMPLATES": "Project templates",
    "PROJECT_TEMPLATES_LIST": "Project templates list",
    "PROMOTION_EMAIL": "Promotion email",
    "PSPID": "PSPID",
    "PUBLICATION_DATE": "Publication date",
    "PUBLIC_CALENDAR": "Public calendar",
    "PUBLIC_CALENDAR_URL": "Public calendar url",
    "PUBLIC_REGISTRATION": "Public registration",
    "PUBLIC_REGISTRATION_AND_MEMBERSHIP_WORKFLOW_EXPLANATION": "Public registration and membership",
    "PUBLIC_REGISTRATION_AND_MEMBERSHIP_WORKFLOW_NAME": "Public registration and membership",
    "PUBLIC_REGISTRATION_WORKFLOW_EXPLANATION": "Public registration: register participants to public event",
    "PUBLIC_REGISTRATION_WORKFLOW_NAME": "Public registration",
    "PUBLISH": "Publish",
    "PUBLISHED": "Published",
    "PUBLISHING": "Publishing...",
    "PUBLISH_CHANGES": "Publish changes",
    "PUBLISH_ERROR": "Publish error",
    "PUBLISH_SAVED_MESSAGES": "Publish saved messages",
    "QR_CODE": "QR code",
    "QR_CODE_FIELD": "QR code field",
    "QR_CODE_ON_BADGE": "QR Code on Badge",
    "QR_CODE_SETTINGS": "QR code settings",
    "QUANTITY": "Quantity",
    "QUERY": "Query",
    "QUERY_TYPE": "Query type",
    "QUESTION": "Question",
    "QUESTIONS": "Questions",
    "QUESTIONS_SETTINGS": "Questions settings",
    "QUICK_SEARCH": "Quick search",
    "READONLY": "Read only",
    "READ_ONLY": "Read only",
    "READ_ONLY_MODE": "Read only mode",
    "READ_SPREADSHEET_FOR_IMPORT": "Read spreadsheet for import",
    "RECAPTCHA": "Recaptcha",
    "RECENTLY_EDITED": "Recently edited",
    "RECTANGULAR": "Rectangular",
    "REFERENCE_NUMBER": "Reference number",
    "REFRESH_LIST": "Refresh list",
    "REFUND": "Refund",
    "REGISTERED": "Registered",
    "REGISTERED_AND_ARRIVED": "Registered and Arrived",
    "REGISTERED_PARTICIPANTS": "Registered participants",
    "REGISTER_AFTER": "Register after",
    "REGISTRATION": "Registration",
    "REGISTRATION_APPROVAL": "Registration/ Approval",
    "REGISTRATION_COMPLETED": "Registration completed",
    "REGISTRATION_COMPLETED_STAGE_NAME": "Registration Completed Stage",
    "REGISTRATION_DEADLINE": "Registration deadline",
    "REGISTRATION_ENGAGEMENT_SEQUENCE": "Registration engagement sequence",
    "REGISTRATION_IN_PROGRESS_STAGE_NAME": "Registration in Progress Stage (Multiple Forms Registrations)",
    "REGISTRATION_LINK_BUTTON": "Registration link button",
    "REGISTRATION_PAID_EVENT": "Registration/ Paid Event",
    "REGISTRATION_PAID_EVENT_WAITING_LIST": "Registration/ Paid Event and Waiting-list",
    "REGISTRATION_PENDING": "Registration pending",
    "REGISTRATION_PENDING_STAGE_NAME": "Registration pending stage name",
    "REGISTRATION_REQUIRED_FOR_THIS_ACTIVITY": "Registration required for this activity",
    "REGISTRATION_TIME": "Registration time",
    "REGISTRATION_WAITINGLIST_WORKFLOW_NAME": "Registration waiting list",
    "REGISTRATION_WAITING_LIST": "Registration/ Waiting-list",
    "REGISTRATION_WAITING_LIST_WORKFLOW_EXPLANATION": "Registration waiting list: registration workflow with max capacity and waiting list option",
    "REGISTRATION_WORKFLOWS": "Registration workflows",
    "REGISTRATION_WORKFLOW_EXPLANATION": "Registration: register participants to invite-only events",
    "REGISTRATION_WORKFLOW_NAME": "Registration",
    "REGULAR": "Regular",
    "REJECTED": "Rejected",
    "REJECTED_AT": "Rejected at",
    "REMOVE": "Remove",
    "REMOVE_ALL": "Remove all",
    "REMOVE_FROM_ACTIVITY": "Remove from activity",
    "REMOVE_PARTICIPANT_FROM_ACTIVITY_DIALOG_ARE_YOU_SURE": "Are you sure you want to remove selected participants from the activity?",
    "REMOVE_PARTICIPANT_FROM_ACTIVITY_DIALOG_TITLE": "Remove participant from activity",
    "REMOVE_TEAM": "Remove team",
    "REMOVE_TEAMS": "Remove teams",
    "REORDER": "Reorder",
    "REORDER_STAGES": "Re-order stages",
    "REORDER_WORKFLOW_AUTOMATIONS": "Re-order workflow automations",
    "REPEAT": "Repeat",
    "REPEAT_MONTHLY_ON": "Repeat monthly on",
    "REPEAT_NEW_PASSWORD": "Repeat new password",
    "REPEAT_WEEKLY_ON": "Repeat weekly on",
    "REPETITION_RULES": "Repetition rules",
    "REPLACE_TEAMS": "Replace teams",
    "REPLACE_WITH": "Replace with",
    "REPLY_EMAIL": "Reply email",
    "REPORT": "Report",
    "REPORTING": "Reporting",
    "REPORTS": "Reports",
    "REPORTS_LIST": "Reports list",
    "REPORT_CREATE": "Add report",
    "REPORT_CREATE_LOCAL": "Add event report",
    "REPORT_DELETE": "Delete report",
    "REPORT_DELETE_LOCAL": "Delete event report",
    "REPORT_GROUP_MAX_UNITS": "Total available products",
    "REPORT_GROUP_RESERVED": "Reserved",
    "REPORT_GROUP_SOLD": "Total quantity sold",
    "REPORT_READ": "View report",
    "REPORT_SCOPES": "Report capabilities",
    "REPORT_TYPE_ACTIVITY_ATTENDANCE": "Activity Report - activity row based",
    "REPORT_TYPE_EVENTS": "Events",
    "REPORT_TYPE_EVENT_PARTICIPANTS": "Event participants",
    "REPORT_TYPE_PARTICIPANTS_CROSS_EVENTS": "Participants cross events",
    "REPORT_TYPE_PARTICIPANT_ACTIVITY_ATTENDANCE": "Activity Report - participant row based",
    "REPORT_TYPE_PARTICIPANT_ACTIVITY_GROUP_ATTENDANCE": "Activity Group Report - participant based",
    "REPORT_TYPE_PARTICIPANT_ORDER": "Participants order",
    "REPORT_TYPE_ROOM_OCCUPATION": "Meeting room occupation",
    "REPORT_TYPE_USER_ACTIVITY": "User activity",
    "REPORT_UDPATE": "Edit report",
    "REPORT_UPDATE": "Edit report",
    "REPORT_UPDATE_LOCAL": "Edit event report",
    "REQUEST": "Request",
    "REQUESTED": "Requested",
    "REQUESTER": "Requester",
    "REQUESTERS": "Requesters",
    "REQUESTERS_LIST": "Requesters list",
    "REQUESTER_DETAILS": "Requester details",
    "REQUESTER_FIELD": "Requester field",
    "REQUESTS": "Requests",
    "REQUEST_DASHBOARD": "Request dashboard",
    "REQUEST_DETAILS": "Request details",
    "REQUEST_ROOM": "Request room",
    "REQUIRED": "Required",
    "REQUIRED_FOR_PLANNERS": "Required for planners",
    "RESCHEDULE": "Reschedule",
    "RESCHEDULED": "Rescheduled",
    "RESCHEDULED_AT": "Rescheduled at",
    "RESEND": "Resend",
    "RESERVED_PROMOTION_TIME": "Reserved promotion time",
    "RESERVED_REGISTRATION_TIME": "Reserved registration time",
    "RESERVED_TIME_TO_COMPLETE_REGISTRATION_FORM": "Reserved time to complete registration",
    "RESET": "Reset",
    "RESET_CHANGES": "Reset changes",
    "RESET_PASSWORD": "Reset password",
    "RESET_PASSWORD_CONFIRMATION_DIALOG_CONTENT": "Do you want to send a reset password email?",
    "RESET_PASSWORD_CONFIRMATION_DIALOG_TITLE": "Reset password email",
    "RESET_PASSWORD_MENU_ACTION": "Reset password",
    "RESET_PASSWORD_NOTIFICATION_SUCCESS": "An email with a password reset link has been sent if the account exists",
    "RESET_YOUR_PASSWORD": "Reset your password",
    "RESOLVE_ISSUES": "Resolve issues",
    "RESTORE": "Restore",
    "RESULT_URL": "Result URL",
    "RETYPE_PASSWORD": "Retype Password",
    "REVERT_TO_PUBLISHED": "Revert to published",
    "REVIEW_AND_UPDATE_IMPORT_ERRORS": "Review and Update Import Errors",
    "REVIEW_DUPLICATES": "Review Duplicates",
    "REVIEW_SOLVE_DUPLICATE": "Review & solve duplicate",
    "REVISION_CONFLICT": "Revision conflict",
    "RIGHT": "Right",
    "RIGHTS": "Rights",
    "RIGHT_AND_UP": "Right and up",
    "RIGHT_MENU_DRAWER": "Right menu drawer",
    "ROLE": "Role",
    "ROLES": "Roles",
    "ROLE_DEFINITION": "Role definition",
    "ROLE_DEFINITION_PREVIEW": "Role definition (Preview)",
    "ROLE_DETAILS": "Role details",
    "ROLE_FIELDS": "Role fields",
    "ROLE_NAME": "Role name",
    "ROOM": "Room",
    "ROOMS": "Rooms",
    "ROOMS_MANAGEMENT": "Rooms management",
    "ROOMS_OVERVIEW": "Rooms overview",
    "ROOM_ACCESS": "Room access",
    "ROOM_AVAILABLE_RANGE_OF_TIME": "Range of time in which the room is available during the selected day",
    "ROOM_BOOKINGS": "Room bookings",
    "ROOM_BOOKING_PROCESSES": "Room booking processes",
    "ROOM_BOOKING_STATUS": "Room booking status",
    "ROOM_MANAGEMENT_APPROVE_BOOKING": "Approve room bookings",
    "ROOM_MANAGEMENT_APPROVE_BOOKING_LOCAL": "Approve booking",
    "ROOM_MANAGEMENT_CREATE": "Add locations/rooms",
    "ROOM_MANAGEMENT_CREATE_LOCAL": "Add room",
    "ROOM_MANAGEMENT_DELETE": "Delete locations/rooms",
    "ROOM_MANAGEMENT_DELETE_LOCAL": "Delete room",
    "ROOM_MANAGEMENT_READ": "View locations/rooms",
    "ROOM_MANAGEMENT_READ_LOCAL": "View room",
    "ROOM_MANAGEMENT_SCOPES": "Rooms capabilities",
    "ROOM_MANAGEMENT_SCOPES_EXT": "Rooms management",
    "ROOM_MANAGEMENT_UPDATE": "Edit locations/rooms",
    "ROOM_MANAGEMENT_UPDATE_LOCAL": "Edit room",
    "ROOM_REQUESTS": "Room requests",
    "ROOM_TYPE": "Room type",
    "ROTATE_180": "Rotate 180 deg",
    "ROWS": "Rows",
    "ROW_COUNT": "Row count",
    "SALES_BY_PRODUCT_QUANTITY_WIDGET_DESCRIPTION": "Display sold quantity, reserved quantity and total quantity of selected products",
    "SALES_BY_PRODUCT_QUANTITY_WIDGET_TITLE": "Product Quantity",
    "SALES_BY_PRODUCT_WIDGET_DESCRIPTION": "Total revenue of the selected products",
    "SALES_BY_PRODUCT_WIDGET_TITLE": "Revenue",
    "SAP_FINANCE": "SAP Finance",
    "SATURDAY": "Saturday",
    "SAVE": "Save",
    "SAVED": "Saved",
    "SAVE_AND_CONTINUE_TO_WEBHOOK": "Save and continue to webhook",
    "SAVE_AND_PROCEED": "Save and proceed",
    "SAVE_BEFORE_DISPLAYING_URL": "In order to display the URL you first need to fill in the fields and click on \"SAVE\"",
    "SAVE_CHANGES": "Save changes",
    "SAVE_ERROR": "Save error",
    "SAVE_NEW_PASSWORD": "Save new password",
    "SAVING": "Saving...",
    "SCALE": "Scale",
    "SCHEDULE": "Schedule",
    "SCHEDULE_EMAIL": "Schedule mail",
    "SCHEDULE_IS_INVALID": "Schedule is invalid",
    "SCHEDULE_THE_REPORT": "Schedule the report",
    "SCOPES": "Scopes",
    "SEARCH": "Search",
    "SEARCH_AMENITIES": "Search amenities",
    "SEARCH_EVENTS": "Search events",
    "SEARCH_ITEMS_TITLE": "Search for items",
    "SEARCH_LOCATIONS": "Search locations",
    "SEATS": "Seats",
    "SEATS_AVAILABLE": "Seats Available",
    "SEATS_HAS_BEEN_ADDED": "Seats has been added",
    "SECONDS": "Seconds",
    "SECRETS_SHOWN_ONCE": "For security reasons, we only show the information below once. It will not be possible to retrieve it later on. Please, copy the client id and the client secret, and store them in a safe place.",
    "SECTION_HEADLINE": "Section headline",
    "SECTION_NAME": "Section name",
    "SECTION_VERSION_TYPE": "Section version type",
    "SECURITY_KEY": "Security key",
    "SEE_POSTER_DETAILS": "See poster details",
    "SEE_PROGRESS": "See progress",
    "SELECT": "Select",
    "SELECTED": "Selected",
    "SELECTED_APPLICABLE_SOURCE_FOR_SELECTED_PARTICIPANTS": "Selected applicable source for selected participants",
    "SELECTED_ITEMS": "Selected items",
    "SELECTED_PARTICIPANTS": "Selected participants",
    "SELECTED_ROWS": "Selected rows",
    "SELECTOR": "Selector",
    "SELECT_ACTIVITY": "Select activity",
    "SELECT_ACTIVITY_STAGES_USED_TO_SHOW_PARTICIPANTS": "Select activity stages used to show participants",
    "SELECT_ALL": "Select all",
    "SELECT_ALL_ITEMS_FROM_THE_ENTIRE_LIST": "Select all items from the entire list",
    "SELECT_AN_EVENT_PRESET": "Select an event preset",
    "SELECT_APPLICABLE_SOURCE_FOR_SELECTED_PARTICIPANTS": "Select applicable source for selected participants",
    "SELECT_A_REPORTING_WIDGET_DIALOG_SUBTITLE": "Select a reporting widget that you'd like to include in this dashboard",
    "SELECT_CATEGORY_FIELD": "Select category field",
    "SELECT_CRM_OBJECT": "Select CRM object",
    "SELECT_DASHBOARD": "Select dashboard",
    "SELECT_DEPENDENCY_FIELD": "Select dependency field",
    "SELECT_DETAIL_VIEW_FIELDS": "Select detail view fields",
    "SELECT_EMAIL_CAMPAIGN": "Select email campaign",
    "SELECT_ENTITY": "Select entity",
    "SELECT_EVENT": "Select event",
    "SELECT_EVENT_APP": "Select EventApp",
    "SELECT_EVENT_TEMPLATE": "Select event template",
    "SELECT_FIELDS": "Select fields",
    "SELECT_FIELD_VALUES_MATCH": "Map field values",
    "SELECT_FILE": "Select file",
    "SELECT_FORMS": "Select forms",
    "SELECT_GENERIC_WORKFLOW": "Select Generic Workflow",
    "SELECT_ICON": "Select icon",
    "SELECT_LIST_VIEW_FIELDS": "Select list view fields",
    "SELECT_MERGE_TAG": "Select merge-tag",
    "SELECT_PROCESS": "Select process",
    "SELECT_PROFILE": "Select profile",
    "SELECT_PROJECT": "Select project",
    "SELECT_PROJECT_TEMPLATE": "Select project template",
    "SELECT_TEAMS": "Select team(s)",
    "SELECT_TEMPLATE": "Select template",
    "SELECT_THE_ROW_TO_KEEP_REMOVE_THE_OTHER_ONES": "Select the row to keep, remove the others",
    "SELECT_USER": "Select user",
    "SELECT_VIEW": "Select view",
    "SENDING_SCHEDULE": "Sending schedule",
    "SEND_EMAIL": "Send email",
    "SEND_EMAIL_LATER": "Send email later",
    "SEND_EMAIL_NOW": "Send email now",
    "SEND_EMAIL_TO": "Send email to",
    "SEND_EMAIL_TO_ANOTHER_EMAIL_FIELD": "Send email to another email field",
    "SEND_EMAIL_TO_APPROVER": "Send access link to Approver",
    "SEND_GENERIC_EMAIL": "Send generic email",
    "SEND_MESSAGE": "Send message",
    "SEND_MESSAGE_TO_USER": "Send message to user",
    "SEND_NOW": "Send now",
    "SEND_OBJECT": "Send to external CRM",
    "SEND_PASSWORD_RESET_LINK": "Send Password Reset link",
    "SEND_TEST_EMAIL": "Send test email",
    "SEND_TIME": "Send time",
    "SENT": "Sent",
    "SENT_AT": "Sent at",
    "SERIES": "Series",
    "SERIES_CONTROLL_SCOPES": "Series Control Scopes",
    "SERIES_CONTROL_SCOPES": "Event series extra capabilities",
    "SERIES_CREATE": "Add event series",
    "SERIES_DELETE": "Delete event series",
    "SERIES_EVENT": "Series event",
    "SERIES_PUBLISH": "Publish event series",
    "SERIES_READ": "View event series",
    "SERIES_SCOPES": "Event series capabilities",
    "SERIES_UNPUBLISH": "Series Unpublish",
    "SERIES_UPDATE": "Edit event series",
    "SERVER_NAME": "Server Name",
    "SESSIONS": "Sessions",
    "SESSIONS_IN_USE": "Sessions in use",
    "SESSIONS_SETTINGS": "Sessions settings",
    "SETTINGS": "Settings",
    "SETTINGS_ARE_NOT_COMPLETED": "Settings are not completed",
    "SETTINGS_ARE_NOT_VALID": "Settings are not valid",
    "SETTINGS_CHANGED": "Settings changed",
    "SETTINGS_NAME": "Settings name",
    "SETUP": "Setup",
    "SETUP_REQUIRED": "Setup required",
    "SETUP_TIME": "Set-up time",
    "SETUP_TIME_AND_BREAK_OFF_TIME": "Set-up time and break-off time",
    "SET_ALERT": "Set alert",
    "SET_AS_DEFAULT": "Set as default",
    "SET_CANCELLATION_FORM": "Set cancellation form",
    "SET_DATE_TIME_FIELD_TO_CURRENT": "Set date-time field to current time",
    "SET_EMAIL_INTEGRATION_AS_DEFAULT_DELIVERY_FOR_ALL_EMAIL_CAMPAIGNS": "Set email integration as default delivery for all email campaigns",
    "SET_FIELD": "Set field",
    "SET_FIELD_VISIBILITY": "Set field visibility",
    "SET_NEW_PASSWORD": "Set new password",
    "SET_NEW_PASSWORD_EXPLANATION": "Create a new password for your Azavista account",
    "SET_NEW_PASSWORD_NOTIFICATION_SUCCESS": "The password has been successfully reset",
    "SET_REFERENCE_NUMBER": "Set reference number",
    "SET_RELATIVE_DATE_TIME": "Set relative date-time from the start of the event",
    "SET_RELATIVE_TIME": "Set relative time from the start of the event",
    "SET_THANK_YOU_PAGE": "Set thank you page",
    "SET_UP_TIME": "Set-up time",
    "SET_YOUR_COMMON_UTM_PARAMETERS": "Set your common UTM parameters",
    "SHARE_VIEW_TO_ALL_TEAMS": "Share view to all teams",
    "SHARE_VIEW_WITH_OTHER_USERS": "Share view with other users",
    "SHOPPING_CART": "Shopping cart",
    "SHOPPING_CART_BLOCK_TITLE": "Shopping cart - This is a sample preview of the shopping cart",
    "SHOPPING_CART_EMPTY": "Your shopping cart is empty",
    "SHOPPING_CART_V2": "Shopping Cart V2",
    "SHORT_NAME": "Short name",
    "SHORT_NAME_IS_ALREADY_SELECTED": "Short name '{{name}}' is already selected",
    "SHOULD_BE_EMAIL": "This field should be an email",
    "SHOW_ADD_TO_CALENDAR": "Show add to calendar",
    "SHOW_ALL_PARTICIPANTS": "Show all participants",
    "SHOW_ERRORS": "Show errors",
    "SHOW_EVENT_PRODUCTS": "Show event products",
    "SHOW_FIELD_IN_CREATE_POPUP": "Show field in create popup",
    "SHOW_FREE_SLOTS_WHICH_WILL_BECOME_AVAILABLE_IN": "Show free slots which will become available in",
    "SHOW_IN_MENU": "Show in menu",
    "SHOW_IN_MENU_NOT_IN_TAB": "Show in menu not in tab",
    "SHOW_IN_MY_TIME": "Show in my time",
    "SHOW_NOTIFICATIONS_WHEN_A_COMMENT_HAS_BEEN_MENTIONED": "Show notifications when a comment has been mentioned",
    "SHOW_NOTIFICATIONS_WHEN_A_TASK_HAS_BEEN_ASSIGNED": "Show notifications when a task has been assigned",
    "SHOW_NOTIFICATIONS_WHEN_A_TASK_HAS_BEEN_COMPLETED": "Show notifications when a task has been completed",
    "SHOW_PREVIEW": "Show preview",
    "SHOW_QR_CODE": "Show QR code",
    "SHOW_SELECTED_ITEMS": "Show selected items",
    "SHOW_ZPL_TEMPLATE": "Show ZPL template",
    "SIGNUP_NOW": "Sign up now",
    "SINGLE_COLUMN_FORM": "Single column form",
    "SINGLE_COLUMN_READ_ONLY_FORM": "Single column read-only form",
    "SINGLE_COLUMN_VIEW_FIELD_SECTION": "Single column view fields section",
    "SITE_NAME": "Site name",
    "SIX_IMAGE": "6 images",
    "SIZE": "Size",
    "SKIP_THE_EMAIL_ADDRESS_STEP": "Skip the email address step",
    "SLUG": "Slug",
    "SOCIAL_MEDIA": "Social media",
    "SOCIAL_SHARE": "Social Share",
    "SOCIAL_SHARE_SETTINGS": "Social Share Settings",
    "SOLVE_DUPLICATE": "Solve duplicate",
    "SOLVE_DUPLICATES": "Solve duplicates",
    "SOLVING_DATA": "Solving data",
    "SOME_FIELDS_CONTAIN_INVALID_VALUE": "Some fields contain invalid value",
    "SOURCE": "Source",
    "SOURCES": "Sources",
    "SPEAKERS": "Speakers",
    "SPEAKER_INFO": "Speaker info",
    "SPECIFIED_START_AND_END_DATES_ARE_INVALID": "Specified start and end dates are invalid. Start date must be before end date.",
    "SPLITTER_CONDITION1": "Splitter-1 condition",
    "SPLITTER_CONDITION2": "Splitter-2 condition",
    "SPLITTER_OUTPUT1": "Splitter 1",
    "SPLITTER_OUTPUT2": "Splitter 2",
    "SPLITTER_STAGE_NAME": "Splitter stage name",
    "SPLITTER_WORKFLOW_EXPLANATION": "Splitter workflow explanation",
    "SPLITTER_WORKFLOW_NAME": "Splitter workflow",
    "SPONSOR_PAGE": "Sponsor page",
    "SPREADSHEET_COLUMN_TITLE": "Spreadsheet column title",
    "SQUARE": "Square",
    "STAGE": "Stage",
    "STAGES": "Stages",
    "STAGES_CREATE": "Add stages",
    "STAGES_DELETE": "Delete stages",
    "STAGES_READ": "View stages",
    "STAGES_SCOPES": "Stages",
    "STAGES_UPDATE": "Edit stages",
    "STAGE_ACTION_WORKFLOW_EXPLANATION": "Stage action: send an email when a stage is changed by the planner",
    "STAGE_ACTION_WORKFLOW_NAME": "Stage action",
    "STAGE_CHANGE_TRIGGER": "Stage change trigger",
    "STAGE_FIELDS": "Stage fields",
    "STAGE_FORM_SUBMIT": "Stage form submit",
    "STAGE_NAME": "Stage name",
    "STANDALONE_APP": "Standalone app",
    "STANDARD_MODULES_IN_EVERY_EVENT": "Standard modules in every event",
    "STARS": "Stars",
    "START": "Start",
    "STARTED": "Started",
    "STARTED_AT": "Started at",
    "STARTING_PROCESS": "Starting process",
    "START_DATE": "Start date",
    "START_DATE_FIELD": "Start date field",
    "START_DATE_MUST_BE_BEFORE_END_DATE": "Start date must be before end date",
    "START_REFUND_PROCESS": "Start Refund Process",
    "START_SELLING_AT": "Schedule sales to start",
    "START_TIME": "Start time",
    "START_TYPING_TO_FILTER": "Start typing to filter...",
    "STATUS": "Status",
    "STATUS_CHANGED_TRIGGER": "Status changed trigger",
    "STATUS_MAPPING": "Status mapping",
    "STAY_SIGNED_IN": "Stay signed in",
    "STOP": "Stop",
    "STOP_SELLING_AT": "Schedule sales to stop",
    "STREET": "Street",
    "STYLE_TYPE": "Style type",
    "SUBCATEGORY": "Subcategory",
    "SUBJECT": "Subject",
    "SUBPARTICIPANT_CONFIRMATION_EMAIL": "Sub-participant's confirmation email",
    "SUBPARTICIPANT_FORM_FIELDS": "Sub-participant form fields",
    "SUBSCRIPTIONS": "Subscriptions",
    "SUBTOTAL": "Subtotal",
    "SUBTYPE": "Sub-type",
    "SUB_PARTICIPANT": "Sub-participant",
    "SUM": "Sum",
    "SUMMARY": "Summary",
    "SUNDAY": "Sunday",
    "SUPERADMIN": "Superadmin",
    "SUPERADMIN_REPORT": "Superadmin report",
    "SURVEY_WORKFLOW_EXPLANATION": "Invite arrived participants for the after event survery",
    "SURVEY_WORKFLOW_NAME": "Survey",
    "SYNC_DIRECTION": "Sync direction",
    "SYNC_PREVIEW": "Sync preview",
    "SYSTEM_EMAIL": "System email",
    "SYSTEM_EMAILS": "System emails",
    "SYSTEM_EMAIL_FIELDS": "System email fields",
    "SYSTEM_FONTS": "System fonts",
    "TAB": "Tab",
    "TAB_NAME": "Tab name",
    "TAG": "Tag",
    "TARGET": "Target",
    "TARGET_CRM_FIELD": "Target CRM field",
    "TASK": "Task",
    "TASKS": "Tasks",
    "TASK_FIELDS": "Task fields",
    "TASK_OWNER": "Task owner",
    "TAX": "Tax",
    "TAXES": "Taxes",
    "TAX_FIELDS": "Tax fields",
    "TAX_NUMBER": "Tax number",
    "TEAM": "Team",
    "TEAMS": "Teams",
    "TEAMS_ACCESS_FOR_PARTICIPANTS": "Teams access for participants",
    "TEAMS_ASSIGNED": "Teams assigned",
    "TEAMS_ASSOCIATED_WITH_ITEM_COPIED_FROM_CLUSTER": "The teams to be associated with the item copied from the cluster",
    "TEAMS_UNASSIGNED": "Teams are unassigned",
    "TEAM_ASSIGNING_ACTIVATED": "Teams can be assigned to participants",
    "TEAM_ASSIGNING_DEACTIVATED": "Team assigning is deactivated",
    "TEAM_DETAILS": "Team details",
    "TEAM_FIELDS": "Team fields",
    "TEMPLATE": "Template",
    "TEMPLATE_EVENT": "Template event",
    "TEMPLATE_NAME": "Template name",
    "TERMS_ADDED": "terms added",
    "TEST": "Test",
    "TEXT": "Text",
    "TEXT_CENTERED": "Centered",
    "TEXT_CONTAINS": "Text contains",
    "TEXT_DOES_NOT_CONTAIN": "Text does not contain",
    "TEXT_JUSTIFY": "Justify",
    "TEXT_LEFT": "Text left",
    "TEXT_LEFT_PLUS_BUTTON": "Text left + Button",
    "TEXT_RIGHT": "Text right",
    "TEXT_RIGHT_PLUS_BUTTON": "Text right + Button",
    "TEXT_SETTINGS": "Text settings",
    "THANK_YOU_EMAIL": "Thank you email",
    "THANK_YOU_PAGE": "Thank you page",
    "THANK_YOU_PAGE_PARTICIPANT_ADDED_TO_WAITINGLIST": "Thank you page - participant added to waiting list",
    "THEME": "Theme",
    "THEMEASSETS_CREATE": "Add theme assets",
    "THEMEASSETS_DELETE": "Delete theme assets",
    "THEMEASSETS_READ": "View theme assets",
    "THEMEASSETS_UPDATE": "Edit theme assets",
    "THEMES": "Themes",
    "THEMES_CREATE": "Add themes",
    "THEMES_DELETE": "Delete themes",
    "THEMES_READ": "View themes",
    "THEMES_SCOPES": "Theme capabilities",
    "THEMES_UPDATE": "Edit themes",
    "THEME_ASSETS": "Manage theme assets",
    "THEME_CREATE": "Theme Create",
    "THEME_DETAIL": "Theme detail",
    "THEME_FIELDS": "Theme fields",
    "THEME_LIST": "Theme list",
    "THEME_TYPE": "Theme type",
    "THEME_UPDATE": "Theme Update",
    "THEN": "Then",
    "THERE_ARE_NO_FIELDS_AVAILABLE": "There are no fields available",
    "THERE_ARE_NO_PUBLISHED_EMAILS_CAMPAIGNS": "There are no published email campaigns",
    "THE_EVENT_HAS_STARTED": "The event has started",
    "THE_EVENT_IS_NO_LONGER_AVAILABLE": "The event is no longer available",
    "THE_FOLLOWING_BUILT_IN_FIELDS_CANNOT_BE_ARCHIVED_DIALOG_TITLE": "The following built in fields cannot be archived",
    "THE_FOLLOWING_FIELDS_ARE_INVALID": "The following fields are invalid",
    "THE_FOLLOWING_FIELDS_ARE_REQUIRED_BUT_NOT_PROVIDED": "The following fields are required but not provided",
    "THE_FOLLOWING_FIELDS_ARE_USED_BUT_NO_LONGER_EXIST_DIALOG_TITLE": "The following fields are used but no longer exist",
    "THE_FOLLOWING_FIELDS_HAVE_ERRORS": "The following fields have errors",
    "THE_FOLLOWING_FIELD_IS_SELECTED_MORE_THAN_ONCE": "The following field is selected more than once",
    "THE_SPECIFIED_FIELD_TYPE_IS_NOT_SUPPORTED": "The specified field type is not supported",
    "THIS_AND_FOLLOWING_EVENTS": "This and following events",
    "THIS_EVENT": "This event",
    "THIS_EVENT_APP_MODULE_DOES_NOT_HAVE_SETTINGS": "This event app module does not have settings",
    "THIS_EVENT_ONLY": "This event only",
    "THIS_FIELD_IS_REQUIRED": "This field is required",
    "THIS_IS_A_PREVIEW_OF_EMAIL": "This is a preview of your email. If you want to make any design or copy changes, please visit our Email Design Studio.",
    "THIS_MIGHT_BE_NETWORK_CONNECTIVITY_ERROR": "This might be network connectivity error",
    "THIS_VIEW_CANNOT_BE_EDITED_BY_YOU": "This view can't be edited by you",
    "THIS_WINDOW": "This window",
    "THREE_HEADINGS": "Three headings",
    "THREE_IMAGE": "3 images",
    "THREE_IMAGE_GALLERY": "Three image gallery",
    "THREE_ROWS": "Three rows",
    "THROTTLING": "Throttling",
    "THROTTLING_TIME": "Throttling time",
    "THUMBS": "Thumbs",
    "THURSDAY": "Thursday",
    "TICKET": "Ticket",
    "TICKETS_AND_PRODUCTS": "Tickets and products",
    "TIME": "Time",
    "TIMESTAMP": "Timestamp",
    "TIMES_OPENED": "Times opened",
    "TIMEZONE": "Timezone",
    "TIME_FORMAT": "Time format",
    "TIME_ZONE": "Time zone",
    "TITLE": "Title",
    "TITLE_LINE": "Title line",
    "TITLE_MR": "Mr.",
    "TITLE_MS": "Ms.",
    "TO": "To",
    "TODAY": "Today",
    "TOKENIZATION_KEY": "Tokenization key",
    "TOP_MENU": "Top menu",
    "TOTAL": "Total",
    "TOTAL_CAPACITY": "Total Capacity",
    "TOTAL_ORDER_VALUE": "Total order value",
    "TOTAL_PARTICIPANTS": "Total participants",
    "TOTAL_SEATS": "Total seats",
    "TO_ALLOW_PAYMENTS_BY_INVOICE_CREATE_AN_INVOICE_INTEGRATION_IN_THE_GENERIC_INTEGRATION_MENU": "To allow payments by invoice, create an invoice integration in the generic integration menu",
    "TO_ALLOW_PAY_BY_INVOICE_CREATE_AN_INVOICE_PAYMENT_INTEGRATION": "To allow pay by invoice, create an invoice payment integration",
    "TO_EMAIL": "To email",
    "TO_EVENT_START_DATE": "To event start date",
    "TO_LOCAL_TIME": "To (local time)",
    "TO_THIS_VALUE": "To this value",
    "TRACKING_PIXEL": "Tracking pixel",
    "TRAFFIC": "Traffic",
    "TRANSACTION": "Transaction",
    "TRANSACTION_ITEM": "Transaction item",
    "TRANSACTION_LOG": "Transaction log",
    "TRANSACTION_STATUS": "Transacton status",
    "TRANSLATE_EMAIL_SUBJECT": "Translate email subject",
    "TRANSLATE_PAGE_NAME": "Translate Page Name",
    "TRANSLATION": "Translation",
    "TRANSLATIONS": "Translations",
    "TRANSLATION_KEY": "English translation",
    "TRAVEL_MANAGEMENT": "Travel Management",
    "TRIGGER": "Trigger",
    "TRIGGER_NAME": "Trigger name",
    "TRIGGER_STATUSES": "Trigger statuses",
    "TRIGGER_VALUE": "Trigger value",
    "TUESDAY": "Tuesday",
    "TUTORIAL_VIDEOS": "Tutorial videos",
    "TWO_COLUMNS_FORM": "Two columns form",
    "TWO_COLUMNS_GRID": "Two columns grid",
    "TWO_COLUMNS_READ_ONLY_FORM": "Two columns read-only form",
    "TWO_COLUMNS_TEXT": "Two columns text",
    "TWO_COLUMNS_VIEW_FIELD_SECTION": "2 columns view fields section",
    "TWO_IMAGE": "2 images",
    "TWO_IMAGE_AND_TEXT": "Two Images and Text",
    "TWO_IMAGE_AND_TEXT_BUTTON_V1": "Two Images and Text - Button v1",
    "TWO_IMAGE_AND_TEXT_BUTTON_V2": "Two Images and Text - Button v2",
    "TWO_IMAGE_GALLERY": "Two image gallery",
    "TYPE": "Type",
    "TYPE_A_VALUE": "Type a value",
    "TYPE_OF_TEXT_AREA": "Type of text area",
    "TYPE_TO_FILTER_BLOCKS": "Type to filter blocks",
    "TYPOGRAPHY": "Typography",
    "TYPOGRAPHY_HEADING": "Custom Heading",
    "UNASSIGN": "Un-assign",
    "UNASSIGNED_ACTIVITIES": "Unassigned activities",
    "UNASSIGNED_TICKETS_ALLOWED": "Allow unassigned ticket",
    "UNASSIGN_ADMINS_FROM_TEAM_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected admins from the team?",
    "UNASSIGN_ADMINS_FROM_TEAM_DIALOG_TITLE": "Unassign admins from team",
    "UNASSIGN_CONTACTS_FROM_ORGANIZATION_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected contacts from the organization?",
    "UNASSIGN_CONTACTS_FROM_ORGANIZATION_DIALOG_TITLE": "Unassign contacts from organization",
    "UNASSIGN_EVENTS": "Unassign event(s)",
    "UNASSIGN_EVENTS_ARE_YOU_SURE": "Are you sure to unassign event(s)?",
    "UNASSIGN_EVENT_FROM_PRODUCT_GROUP_DIALOG_ARE_YOU_SURE": "Are you sure that you want to unassign the selected event(s) from the product group?",
    "UNASSIGN_EVENT_FROM_PRODUCT_GROUP_DIALOG_TITLE": "Unassign Event(s) from Product Group",
    "UNASSIGN_EVENT_PROJECT_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign the selected event(s) from the project?",
    "UNASSIGN_EVENT_PROJECT_DIALOG_TITLE": "Unassign event(s)",
    "UNASSIGN_FROM_TEAMS": "Unassign from teams",
    "UNASSIGN_MODERATOR": "Unassign moderator",
    "UNASSIGN_MODERATOR_FROM_ACTIVITY_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected participants as moderators from the activity?",
    "UNASSIGN_MODERATOR_FROM_ACTIVITY_DIALOG_TITLE": "Unassign participant as moderator",
    "UNASSIGN_PARTICIPANTS_FROM_TEAMS": "Unassign participants from teams",
    "UNASSIGN_PRODUCT_FROM_PRODUCT_GROUP_DIALOG_ARE_YOU_SURE": "Are you sure that you want to unassign the selected product(s) from the product group?",
    "UNASSIGN_PRODUCT_FROM_PRODUCT_GROUP_DIALOG_TITLE": "Unassign Product from Product Group",
    "UNASSIGN_ROLES_FROM_TEAM_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected roles from the team?",
    "UNASSIGN_ROLES_FROM_TEAM_DIALOG_TITLE": "Unassign roles from team",
    "UNASSIGN_SPEAKER": "Unassign speaker",
    "UNASSIGN_SPEAKER_FROM_ACTIVITY_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected participants as speakers from the activity?",
    "UNASSIGN_SPEAKER_FROM_ACTIVITY_DIALOG_TITLE": "Unassign participant as speaker",
    "UNASSIGN_TEAMS_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected teams",
    "UNASSIGN_TEAMS_DIALOG_TITLE": "Unassign teams",
    "UNASSIGN_TEAMS_FROM_EVENT_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected teams from the event?",
    "UNASSIGN_TEAMS_FROM_EVENT_DIALOG_TITLE": "Unassign teams from event",
    "UNASSIGN_TEAMS_FROM_EVENT_SERIES_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected teams from the series?",
    "UNASSIGN_TEAMS_FROM_EVENT_SERIES_DIALOG_TITLE": "Unassign teams from series",
    "UNASSIGN_TEAMS_FROM_LOCATION_DIALOG_ARE_YOU_SURE": "Are you sure that you want to unassign the selected team(s) from the location?",
    "UNASSIGN_TEAMS_FROM_LOCATION_DIALOG_TITLE": "Unassign teams from location",
    "UNASSIGN_TEAMS_FROM_THEME_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected teams from the theme?",
    "UNASSIGN_TEAMS_FROM_THEME_DIALOG_TITLE": "Unassign teams from theme",
    "UNASSIGN_TEAMS_FROM_USER_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected teams from the user?",
    "UNASSIGN_TEAMS_FROM_USER_DIALOG_TITLE": "Unassign teams from user",
    "UNASSIGN_TEAM_PROJECT_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign the selected team(s) from the project?",
    "UNASSIGN_TEAM_PROJECT_DIALOG_TITLE": "Unassign team(s)",
    "UNASSIGN_TEAM_TASK_DIALOG_ARE_YOU_SURE": "Are you sure to unassign the selected team(s) from task",
    "UNASSIGN_TEAM_TASK_DIALOG_TITLE": "Unassign team(s) from task",
    "UNASSIGN_USERS_FROM_TEAM_DIALOG_ARE_YOU_SURE": "Are you sure you want to unassign selected users from the team?",
    "UNASSIGN_USERS_FROM_TEAM_DIALOG_TITLE": "Unassign users from team",
    "UNASSIGN_USER_TASK_DIALOG_ARE_YOU_SURE": "Are you sure to unassign user(s) from task",
    "UNASSIGN_USER_TASK_DIALOG_TITLE": "Unassign user(s) from task",
    "UNDEFINED_CANCELLATION_PERIODS": "Undefined cancellation periods have a 0% cancellation cost. In other words, if the participant cancels at a time that is not captured by the terms added above, then the participant receives a full refund.",
    "UNIQUE_EMAIL_VALIDATION": "Unique email validation",
    "UNIQUE_TRAFFIC": "Unique traffic",
    "UNNAMED_DASHBOARD": "Unnamed dashboard",
    "UNPUBLISH": "Unpublish",
    "UNSAVED_CHANGES_LOST": "Any unpublished changes will be lost.",
    "UNSUBSCRIBED": "Unsubscribed",
    "UP": "Up",
    "UPDATE": "Update",
    "UPDATED_AT": "Updated at",
    "UPDATE_ACTIVITY_CONDITION": "Update activity condition",
    "UPDATE_ACTIVITY_START_AND_END_TO_SOLVE_CONFLICTS": "Update the start and/or end of the activity to solve the conflicts",
    "UPDATE_ARRIVAL_DEPARTURE_TIME": "Update arrival departure time",
    "UPDATE_BOOKING_STATUS": "Update booking status",
    "UPDATE_CATEGORY": "Update category",
    "UPDATE_CONDITION": "Update condition",
    "UPDATE_CRM_CONTACT_VALUE_TO_EVENT_PARTICIPANT_VALUE_WHEN_PARTICIPANT_IS": "Update CRM contact value to Event Participant value when participant is",
    "UPDATE_FIELD": "Update field",
    "UPDATE_FIELD_VALUE": "Update field value",
    "UPDATE_FORMS": "Update forms",
    "UPDATE_GLOBAL_PRODUCT_CONFIRMATION": "This is a global product. If this product is changed, it will change for all events to which this product is connected.",
    "UPDATE_MENU_ITEM": "Update menu item",
    "UPDATE_MULTIPLE_ORGANIZATION_FIELDS": "Update multiple organization fields",
    "UPDATE_ORGANIZATION_ACTION": "Update organization",
    "UPDATE_PARTICIPANTS": "Update participants",
    "UPDATE_PARTICIPANTS_STAGE": "Update participants stage",
    "UPDATE_PRODUCT": "Update product",
    "UPDATE_SERIES_EVENT": "Update series event",
    "UPDATE_STAGE": "Update stage",
    "UPDATE_STATUS": "Update status",
    "UPDATE_TAG": "Update tag",
    "UPDATE_THE_PARTICIPANT_VALUE_WITH_THE_CONTACT_VALUE": "Update the participant value with the contact value",
    "UPDATE_THIS_FIELD": "Update this field",
    "UPDATING_ORDERS": "Updating orders",
    "UPLOAD": "Upload",
    "UPLOADING_FLOOR_PLAN": "Uploading floor plan",
    "UPLOAD_A_NEW_DOCUMENT": "Upload a new document",
    "UPLOAD_BROWSER_ICON": "Upload browser icon",
    "UPLOAD_EVENT_IMAGE": "Upload event image",
    "UPLOAD_FILE": "Upload file",
    "UPLOAD_FILE_FROM_DESKTOP": "Upload file from desktop",
    "UPLOAD_FROM_CLOUD": "Upload from Cloud (coming soon)",
    "UPLOAD_NEW_PHOTO": "Upload new photo",
    "UPVOTES": "Upvotes",
    "UP_AND_LEFT": "Up and left",
    "UP_AND_RIGHT": "Up and right",
    "UP_SELECT_EVENT_INFO": "You should select one of the events you have previously created as part of the onboarding (for example, the event you created from a template).",
    "URGENT": "Urgent",
    "URL": "Url",
    "USED_SEATS": "Used seats",
    "USER": "User",
    "USERNAME": "Username",
    "USERS": "Users",
    "USERS_ASSIGNED": "Users assigned",
    "USER_ACCOUNT": "User account",
    "USER_DETAILS": "User details",
    "USER_TIMEZONE": "User timezone",
    "USER_TYPE": "User type",
    "USE_CATEGORY": "Use Category",
    "USE_CUSTOM_FIELDS": "Use custom fields",
    "USE_DIFFERENT_DATE_TIME": "Use different date time",
    "USE_ENGAGEMENT_APP_GENERIC_SETTINGS": "Use Engagement app generic settings",
    "USE_EVENT_SETTINGS": "Use event settings",
    "USE_GENERIC_ACTIVITY_SETTINGS": "Use generic activity settings",
    "USE_GLOBAL_SETTINGS": "Use global settings",
    "USE_IN_EVENT": "Use in event",
    "USE_LONGEST_VALUES_FIRST": "Use longest values first",
    "USE_PARTICIPANT_TEAMS": "Use participant teams",
    "USE_PROXY": "Use proxy",
    "USE_READ_ONLY_FORM_DIALOG_TEXT": "Do you want to use read-only fields in this form?",
    "USE_VIEW_IN_ALL_EVENTS": "Use view in all events",
    "USE_WAITING_LIST": "Use waiting list",
    "UTM_CAMPAIGN": "Utm campaign",
    "UTM_CODE": "UTM code",
    "UTM_MEDIUM": "Utm medium",
    "UTM_PARAMETERS": "UTM parameters",
    "UTM_SOURCE": "Utm source",
    "VACANT_SEATS": "Vacant seats",
    "VALIDATION": "Validation",
    "VALIDATION_ERROR": "Validation error",
    "VALID_UNTIL": "Valid until",
    "VALUE": "Value",
    "VALUE_IN_AZAVISTA": "Value in Azavista",
    "VALUE_IN_THE_SPREADSHEET": "Value in the spreadsheet",
    "VERIFY": "Verify",
    "VERIFY_CONTACT_EMAIL_ADDRESS": "Verify contact email address",
    "VERIFY_EMAIL_ADDRESS": "Verify email address",
    "VERSION": "Version",
    "VERSIONS": "Versions",
    "VERSION_1": "Version 1",
    "VERSION_2": "Version 2",
    "VERSION_3": "Version 3",
    "VERSION_TO_COMPARE_AGAINST": "Version to compare against",
    "VIA": "Via",
    "VIDEO": "Video",
    "VIDEO_AUDIO_INTEGRATION": "Video/Audio integration",
    "VIDEO_EMBED_CODE": "Video embed code",
    "VIDEO_GRAY_OUT_BUTTON": "Gray out button",
    "VIDEO_INTEGRATION": "Video integration",
    "VIDEO_LEFT_TEXT_RIGHT": "Video left + Text right",
    "VIDEO_RIGHT_TEXT_LEFT": "Video right + Text left",
    "VIEW": "View",
    "VIEW_COMMENTS": "View comments",
    "VIEW_CONTACTS": "View contacts",
    "VIEW_DETAILED_PROCESS": "View detailed process",
    "VIEW_DETAILS": "View details",
    "VIEW_EVENT_PARTICIPANTS": "View event participants",
    "VIEW_LIST": "View list",
    "VIEW_MODERATOR": "View moderator",
    "VIEW_ORGANIZATIONS": "View organizations",
    "VIEW_OR_EDIT": "View or edit",
    "VIEW_PARTICIPANT": "View participant",
    "VIEW_PARTICIPANTS": "View participants",
    "VIEW_POLL_RESULTS": "View poll results",
    "VIEW_REPORT": "View Report",
    "VIEW_REPORT_ONLINE": "View report online",
    "VIEW_SPEAKER": "View speaker",
    "VIEW_SPREADSHEET_REPORT": "View spreadsheet report",
    "VIRTUAL_EVENT": "Virtual event",
    "VISIBILITY": "Visibility",
    "VISIBLE_FOR_PLANNERS": "Visible for planners",
    "VISUAL_STYLE": "Visual style",
    "WAIT": "Wait",
    "WAITINGLIST": "Waiting list",
    "WAITING_FOR_JOB_TO_COMPLETE": "Waiting for job to complete",
    "WAITING_LIST_EMAIL_CAMPAIGN": "Waiting list email campaign",
    "WAITING_LIST_PROMOTION_EMAIL_CAMPAIGN": "Waiting list promotion email campaign",
    "WAITING_LIST_STAGE_NAME": "Waiting list stage name",
    "WAITING_LIST_THANK_YOU_PAGE": "Waiting list thank you page",
    "WAITING_LIST_WORKFLOWS": "Waiting-lists workflows",
    "WAITING_LIST_WORKFLOW_EXPLANATION": "Waiting-list",
    "WAITING_LIST_WORKFLOW_NAME": "Waiting-list",
    "WAIT_LIST": "Wait list",
    "WAIT_UNTIL_FIELD": "Wait until field",
    "WARNING": "Warning",
    "WATCH_INSTRUCTIONS_VIDEO": "Watch instructions video",
    "WEBHOOK": "Webhook",
    "WEBHOOK_CALL_REQUESTS": "Webhook call requests",
    "WEBHOOK_ID": "Webhook ID",
    "WEBHOOK_SECRET": "Webhook Secret",
    "WEBHOOK_VERIFICATION_KEY": "Webhook verification key",
    "WEBPAGE": "Webpage",
    "WEBPAGE_BUILDER": "Webpage builder",
    "WEBSITE": "Website",
    "WEBSITES": "Websites",
    "WEBSITE_LINK": "Website link",
    "WEBSITE_MANAGEMENT": "Website management",
    "WEBSITE_MENU_EDITOR": "Website menu editor",
    "WEBSITE_MENU_ITEMS": "Website menu items",
    "WEBSITE_PAGES": "Website pages",
    "WEBSITE_PUBLISH_SCOPES": "Manage website publishing",
    "WEBSITE_SCOPES": "Manage event website",
    "WEDNESDAY": "Wednesday",
    "WEEK": "Week",
    "WEEKLY": "Weekly",
    "WEEKS": "Weeks",
    "WHILE_THE_IMPORT_IS_RUNNING_YOU_CAN_CONTINUE_WITH_OTHER_PLATFORM_ACTIVITIES": "While the import is running, you can continue with other platform activities",
    "WHITE": "White",
    "WHITE_LABEL_URL": "White label URL",
    "WHO_CAN_SEE_THIS_EVENT": "Who can see this event?",
    "WIDGETS_ALIGNMENT": "Widgets alignment",
    "WIDGET_TITLE": "Widget title",
    "WIDTH": "Width",
    "WITH_LINE": "With line",
    "WITH_LINK_TO_PAGE_BUTTON": "With Link to Page button",
    "WORKFLOW": "Workflow",
    "WORKFLOWS": "Workflows",
    "WORKFLOW_AUTOMATION": "Workflow automation",
    "WORKFLOW_BLOCK": "Workflow block",
    "WORKFLOW_NO_POSSIBLE_NEXT_WORKFLOW_MESSAGE": "{{workflowTypeNames}} workflows are missing. Please create one to connect the {{outputPinName}} pin.",
    "WORKFLOW_PROCESS": "Workflow process",
    "WORKFLOW_SETTINGS": "Workflow settings",
    "WORKSPACE_ID": "Workspace ID",
    "WORK_BLOCKS": "Workblocks",
    "WRONG_DATES": "Wrong dates",
    "X": "x",
    "Y": "y",
    "YOU_ARE_CURRENTLY_OFFLINE": "You are currently offline. Try to refresh",
    "YOU_ARE_GOING_TO_IMPORT_RATHER_LARGE_FILE": "You are going to import a rather large file with more than 1000 rows. This import may take 10-50 minutes",
    "YOU_HAVE_DELETED_ONE_OR_MORE_VALUES": "You have deleted one or more values for the field. Please indicate how to resolve this in the database.",
    "YOU_WILL_BE_ABLE_TO_RESTORE_DATA": "You will be able to restore data",
    "YOU_WONT_BE_ABLE_TO_RESTORE_DATA": "You won't be able to restore the lost data",
    "ZAPIER_CRM_INTEGRATION": "Zapier External-CRM Integration",
    "ZPL_EDITOR": "ZPL editor"
}